{
  "$comment": "User-facing release notes shown in the app's Changelog pane (all clients). Curated from CHANGELOG.md: user-visible changes only, no internal security/operations details. A version gets a date only when that release actually happens (see docs/release-notes.md). From 7.0 versions are MAJOR.MINOR like the design. Admin-console and infrastructure changes are never listed here (owner rule 2026-10-16): only what app users see. `current` is the running app version and may have no entry here.",
  "schema_version": 2,
  "current": "12.12",
  "areas": [
    {
      "key": "desk",
      "en": "Multi-desktop",
      "fa": "مولتی‌دسکتاپ"
    },
    {
      "key": "ix",
      "en": "Interaction design",
      "fa": "طراحی تعامل"
    },
    {
      "key": "assign",
      "en": "Assigning",
      "fa": "قابلیت اساین کردن"
    },
    {
      "key": "alltasks",
      "en": "All Tasks & Search",
      "fa": "همه‌ی تسک‌ها و جستجو"
    },
    {
      "key": "menu",
      "en": "Projects menu",
      "fa": "منوی پروژه‌ها"
    },
    {
      "key": "projects",
      "en": "Projects",
      "fa": "پروژه‌ها"
    },
    {
      "key": "tasks",
      "en": "Tasks",
      "fa": "تسک‌ها"
    },
    {
      "key": "comments",
      "en": "Comments & updates",
      "fa": "کامنت‌ها و اعلان‌ها"
    },
    {
      "key": "sharing",
      "en": "Sharing",
      "fa": "اشتراک‌گذاری"
    },
    {
      "key": "files",
      "en": "Notes & files",
      "fa": "یادداشت و فایل‌ها"
    },
    {
      "key": "stats",
      "en": "Stats & screen saver",
      "fa": "آمار و اسکرین‌سیور"
    },
    {
      "key": "dates",
      "en": "Dates & calendars",
      "fa": "تاریخ و تقویم"
    },
    {
      "key": "trash",
      "en": "Trash",
      "fa": "سطل زباله"
    },
    {
      "key": "activity",
      "en": "Activity & undo",
      "fa": "فعالیت و آندو"
    },
    {
      "key": "look",
      "en": "Appearance",
      "fa": "ظاهر"
    },
    {
      "key": "account",
      "en": "Profile",
      "fa": "پروفایل"
    },
    {
      "key": "mobile",
      "en": "Mobile & app",
      "fa": "موبایل و اپ"
    },
    {
      "key": "layout",
      "en": "Columns & layout",
      "fa": "ستون‌ها و چیدمان"
    },
    {
      "key": "app",
      "en": "General",
      "fa": "عمومی"
    },
    {
      "key": "sync",
      "en": "Connection & sync",
      "fa": "وضعیت اتصال و همگام‌سازی"
    }
  ],
  "releases": [
    {
      "version": "12.12",
      "status": "released",
      "date": "2026-10-31",
      "items": [
        {
          "area": "files",
          "phases": [
            "P12"
          ],
          "en": "Markdown preview follows the file's language: Persian files read right to left in Preview and Split, English files left to right; code blocks stay left to right",
          "fa": "پیش‌نمایش Markdown از زبان خود فایل پیروی می‌کند: فایل‌های فارسی در Preview و Split راست‌به‌چپ و فایل‌های انگلیسی چپ‌به‌راست نمایش داده می‌شوند؛ بلوک‌های کد چپ‌به‌راست می‌مانند"
        }
      ]
    },
    {
      "version": "12.2",
      "status": "released",
      "date": "2026-10-23",
      "items": [
        {
          "area": "account",
          "phases": [
            "P14"
          ],
          "en": "Telegram in Profile: connect the TaskCool bot with a one-time code, choose the project and list new tasks go to, and set how messages are read (every message or only #task, first line as title, #tags, files, replies as comments)",
          "fa": "تلگرام در پروفایل: اتصال بات TaskCool با یک کد یک‌بارمصرف، انتخاب پروژه و لیستی که تسک‌های جدید به آن می‌روند، و تنظیم نحوه‌ی خواندن پیام‌ها (همه‌ی پیام‌ها یا فقط #task، خط اول به‌عنوان عنوان، #تگ‌ها، فایل‌ها، ریپلای به‌عنوان کامنت)"
        }
      ]
    },
    {
      "version": "12.1",
      "status": "released",
      "date": "2026-10-21",
      "items": [
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "GIF tab in the emoji picker: pick a GIF from the built-in pack to send it as a comment; GIFs play on a loop without a bubble",
          "fa": "تب GIF در انتخاب‌گر اموجی: با انتخاب یک GIF از پک داخلی، به‌صورت کامنت ارسال می‌شود؛ GIFها بدون حباب و به‌صورت حلقه پخش می‌شوند"
        },
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "GIFs load faster: the picker shows a still preview and plays a GIF only on hover; GIFs in comments play only while fully visible on screen; partly hidden ones show a light still preview",
          "fa": "گیف‌ها سریع‌تر لود می‌شوند: انتخاب‌گر یک پیش‌نمایش ثابت نشان می‌دهد و گیف را فقط با هاور پخش می‌کند؛ گیف‌های داخل کامنت فقط وقتی کامل داخل صفحه هستند پخش می‌شوند و بقیه یک پیش‌نمایش ثابت و سبک نشان می‌دهند"
        }
      ]
    },
    {
      "version": "12.0",
      "status": "released",
      "date": "2026-10-21",
      "items": [
        {
          "area": "activity",
          "phases": [
            "P13"
          ],
          "en": "My activity has filters: All, Created, Done, Edited, Commented, Moved and Trash, each with its count",
          "fa": "My activity فیلتر دارد: All، Created، Done، Edited، Commented، Moved و Trash، هر کدام با تعدادش"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "New system filter Bookmarks in the project filter row: shows only the project’s bookmarked tasks; it appears when the project has bookmarks and can be reordered in Project settings like No tag",
          "fa": "فیلتر سیستمی جدید Bookmarks در ردیف فیلتر پروژه: فقط تسک‌های بوک‌مارک‌شده‌ی پروژه را نشان می‌دهد؛ وقتی پروژه بوک‌مارک دارد ظاهر می‌شود و مثل No tag در تنظیمات پروژه جابه‌جا می‌شود"
        },
        {
          "area": "alltasks",
          "phases": [
            "P09"
          ],
          "en": "While you type a search, the sort buttons next to it fold down to the selected one so the text has room; hovering spreads them out again",
          "fa": "هنگام تایپ در جستجو، دکمه‌های مرتب‌سازی کنارش جمع می‌شوند و فقط گزینه‌ی انتخاب‌شده می‌ماند تا متن جا داشته باشد؛ با هاور دوباره باز می‌شوند"
        },
        {
          "area": "alltasks",
          "phases": [
            "P09"
          ],
          "en": "New Deadline sort in All Tasks & Search, Bookmarks and project columns: nearest deadline first, tasks without a deadline at the end",
          "fa": "مرتب‌سازی جدید Deadline در All Tasks & Search، Bookmarks و ستون پروژه‌ها: نزدیک‌ترین ددلاین اول، تسک‌های بدون ددلاین در انتها"
        },
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "Notifications, Mentions and Invites are one Notifications column: All, Comments, Mentions and Invites are filters on one list; mentions are part of the list and marked with an @ badge, accent text and a light tint; pending invites stay at the top under the filters until you accept or decline them",
          "fa": "نوتیفیکیشن، منشن و اینوایت یک ستون Notifications شدند: All، Comments، Mentions و Invites فیلترهای یک لیست‌اند؛ منشن‌ها داخل همان لیست هستند و با نشان @، متن اکسنت و پس‌زمینه‌ی کم‌رنگ مشخص می‌شوند؛ دعوت‌های در انتظار بالای لیست زیر فیلترها می‌مانند تا تأیید یا رد شوند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Bookmarks: bookmark tasks from the right-click menu or ⋯ on an open task; Bookmarks in the Projects menu works like All Tasks & Search, with the same filters, search, sort and task rows; bookmarked tasks show a small marker next to their title",
          "fa": "بوک‌مارک: تسک‌ها را از منوی راست‌کلیک یا ⋯ در تسک باز بوک‌مارک کنید؛ Bookmarks در منوی پروژه‌ها دقیقاً مثل All Tasks & Search کار می‌کند، با همان فیلترها، جستجو، مرتب‌سازی و ردیف تسک‌ها؛ تسک‌های بوک‌مارک‌شده کنار عنوانشان یک نشانه‌ی کوچک دارند"
        },
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "API keys in Profile: create named keys for your own scripts, copy a new key once, see when each was created and last used, and revoke keys",
          "fa": "کلیدهای API در پروفایل: برای اسکریپت‌های خودتان کلید با نام بسازید، کلید جدید را فقط یک بار کپی کنید، تاریخ ساخت و آخرین استفاده‌ی هر کلید را ببینید و کلیدها را باطل کنید"
        },
        {
          "area": "app",
          "phases": [
            "P09"
          ],
          "en": "The version label shows the platform next to the version number: WEB (browser), AND (Android), ATV (Android TV), MAC (macOS) or iOS",
          "fa": "برچسب نسخه، پلتفرم را کنار شماره‌ی نسخه نشان می‌دهد: WEB (مرورگر)، AND (اندروید)، ATV (اندروید تی‌وی)، MAC (مک‌اواس) یا iOS"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "← / → move the selection to the nearest task in the column beside it",
          "fa": "← / → انتخاب را به نزدیک‌ترین تسکِ ستون کناری می‌برد"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "Fixed: ↑/↓ sometimes scrolled the column instead of moving between tasks while a task was open in another column",
          "fa": "رفع اشکال: وقتی تسکی در ستون دیگری باز بود، ↑/↓ گاهی به‌جای حرکت بین تسک‌ها ستون را اسکرول می‌کرد"
        },
        {
          "area": "menu",
          "phases": [
            "P09"
          ],
          "en": "When the Projects column is collapsed to its edge, ☰ opens it as a floating panel over the columns instead of scrolling back to the start; a click outside or Esc closes it",
          "fa": "وقتی ستون پروژه‌ها به لبه جمع شده، ☰ آن را به‌صورت شناور روی ستون‌ها باز می‌کند و دیگر صفحه را به ابتدا اسکرول نمی‌کند؛ با کلیک بیرون یا Esc بسته می‌شود"
        },
        {
          "area": "files",
          "phases": [
            "P09"
          ],
          "en": "Pasting an image into + New task creates a task with that image and opens it with the cursor in the title",
          "fa": "پیست کردن عکس در + New task یک تسک با همان عکس می‌سازد و آن را با کرسر روی عنوان باز می‌کند"
        },
        {
          "area": "activity",
          "phases": [
            "P13"
          ],
          "en": "My activity: creating a task and filling in its title, tags or notes right away now shows as one “Created” entry",
          "fa": "My activity: ساختن تسک و پر کردن فوری عنوان، تگ یا یادداشت آن حالا فقط یک ردیف «Created» ثبت می‌کند"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "Clicking anywhere in a column outside the open task closes it",
          "fa": "کلیک در هر جای ستون بیرون از تسک باز، آن را می‌بندد"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "+ New list puts the cursor in the new list’s name; Enter in a list name selects the list’s first task, or moves to + New task if the list is empty",
          "fa": "+ New list کرسر را روی نام لیست جدید می‌گذارد؛ Enter روی نام لیست، اولین تسک آن را انتخاب می‌کند و اگر لیست خالی باشد، کرسر را به + New task می‌برد"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "Enter in a task title saves it and closes the task, then selects the next task, or puts the cursor in + New task if it was the last in its list (↓ still moves on to tags and people)",
          "fa": "Enter در عنوان تسک، آن را ذخیره می‌کند و تسک را می‌بندد؛ بعد تسک بعدی انتخاب می‌شود، یا اگر آخرین تسک لیست بود، کرسر به + New task می‌رود (↓ همچنان به تگ و افراد می‌رود)"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "Fixed: typing quickly into + New task no longer splits the text into a second task while the first one is opening",
          "fa": "رفع اشکال: تایپ سریع در + New task دیگر وسط باز شدن تسک، ادامه‌ی متن را به یک تسک دوم نمی‌برد"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Fixed: after a done task fades out, the task that moves into its place no longer flashes a strikethrough",
          "fa": "رفع اشکال: بعد از محو شدن تسک دان‌شده، تسکی که جای آن می‌آید دیگر یک لحظه خط‌خورده دیده نمی‌شود"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "Checking off a task with Space selects the next task in the column",
          "fa": "تیک زدن تسک با Space، تسک بعدی همان ستون را انتخاب می‌کند"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "After moving a task to Trash, the next task in the column is selected (or the previous one if it was last)",
          "fa": "بعد از انتقال تسک به سطل زباله، تسک بعدی همان ستون انتخاب می‌شود (اگر آخرین تسک بود، تسک قبلی)"
        }
      ]
    },
    {
      "version": "11.5",
      "status": "released",
      "date": "2026-10-17",
      "items": [
        {
          "area": "account",
          "phases": [
            "P14"
          ],
          "en": "Get notified when someone assigns you a task (Profile › Notifications)",
          "fa": "وقتی کسی تسکی را به شما می‌سپارد اعلان می‌گیرید (پروفایل › اعلان‌ها)"
        }
      ]
    },
    {
      "version": "11.2",
      "status": "released",
      "date": "2026-10-16",
      "items": [
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "Sign in with Google in the TaskCool apps for Mac, iPhone and Android",
          "fa": "ورود با گوگل در اپ‌های تسک‌کول برای مک، آیفون و اندروید"
        }
      ]
    },
    {
      "version": "11.0",
      "status": "released",
      "date": "2026-10-16",
      "items": [
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "Keyboard on task lists (desktop): Space ticks or unticks the selected task (or all selected tasks), and Shift + ↑ / ↓ selects a range of tasks",
          "fa": "کیبورد روی لیست تسک‌ها (دسکتاپ): Space تسک انتخاب‌شده (یا همه‌ی تسک‌های انتخاب‌شده) را تیک می‌زند یا تیکش را برمی‌دارد، و Shift + ↑ / ↓ یک بازه از تسک‌ها را انتخاب می‌کند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "An open task that is done shows its title struck through",
          "fa": "وقتی تسکی که دان شده باز می‌شود، عنوانش خط‌خورده نمایش داده می‌شود"
        },
        {
          "area": "files",
          "phases": [
            "P09"
          ],
          "en": "Images in tasks and comments can be copied or saved: right-click an image (in notes, comments or full screen) for Copy image / Save image, or use the Copy and Save buttons in the full-screen view",
          "fa": "عکس‌های داخل تسک و کامنت را می‌توان کپی یا ذخیره کرد: با راست‌کلیک روی عکس (در یادداشت، کامنت یا نمای تمام‌صفحه) گزینه‌های Copy image و Save image می‌آیند، یا از دکمه‌های Copy و Save در نمای تمام‌صفحه استفاده کنید"
        },
        {
          "area": "desk",
          "phases": [
            "P09"
          ],
          "en": "Changing the theme from the theme button in the Projects column now updates both the default app theme and the current desktop’s theme",
          "fa": "تغییر تم با دکمه‌ی تم در ستون پروژه‌ها، حالا هم تم پیش‌فرض اپ و هم تم دسکتاپ جاری را عوض می‌کند"
        },
        {
          "area": "desk",
          "phases": [
            "P09"
          ],
          "en": "Desktop shortcuts ⌃1–9 also work with a Persian or other non-English keyboard layout",
          "fa": "میان‌بر ⌃1–9 برای عوض کردن دسکتاپ با کیبورد فارسی و بقیه‌ی زبان‌ها هم کار می‌کند"
        },
        {
          "area": "desk",
          "phases": [
            "P09"
          ],
          "en": "After a refresh or a desktop switch you land exactly where you were: horizontal scroll, each column’s vertical scroll and the open task are restored, per desktop",
          "fa": "بعد از رفرش یا عوض کردن دسکتاپ، دقیقاً همان جای قبلی برمی‌گردید: اسکرول افقی، اسکرول عمودی هر ستون و تسک باز برای هر دسکتاپ حفظ می‌شوند"
        },
        {
          "area": "account",
          "phases": [
            "P09"
          ],
          "en": "Profile › Devices opens a bottom sheet listing every signed-in session with its app (web, iOS, Android…), device (model or browser), last activity and IP; the current device is marked, and other sessions can be revoked (tap twice to confirm) or all signed out at once",
          "fa": "پروفایل › Devices یک باتم‌شیت باز می‌کند که همه‌ی سشن‌های لاگین را با اپ (وب، iOS، اندروید…) ، دستگاه (مدل یا مرورگر)، آخرین فعالیت و IP نشان می‌دهد؛ دستگاه فعلی مشخص است و بقیه‌ی سشن‌ها را می‌توان ریوک کرد (با دو بار زدن برای تأیید) یا همه را یک‌جا خارج کرد"
        },
        {
          "area": "menu",
          "phases": [
            "P09"
          ],
          "en": "The Projects list shows the team before each shared project’s name: up to 3 photos, or just a +N count for larger teams; long names get a slightly smaller font when they don’t fit. The + Open in a new column button now appears only on hover, over the task count",
          "fa": "در لیست پروژه‌ها، قبل از اسم هر پروژه‌ی اشتراکی تیم نمایش داده می‌شود: تا ۳ نفر با عکس، و برای تیم‌های بزرگ‌تر فقط تعداد به‌شکل +N؛ اسم‌های طولانی اگر جا نشوند کمی ریزتر می‌شوند. دکمه‌ی + برای باز کردن در ستون جدید فقط با هاور و روی تعداد تسک‌ها نمایش داده می‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P09"
          ],
          "en": "A comment you send now slides gently into the list, and a new reaction pops in smoothly under the comment",
          "fa": "کامنتی که می‌فرستید حالا نرم به لیست اضافه می‌شود و ری‌اکشن جدید هم با یک حرکت نرم زیر کامنت ظاهر می‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P09"
          ],
          "en": "The commenter’s photo now sits right beside the bubble, with a matching corner so photo and bubble look joined; in reaction chips the photos come first, then the emoji",
          "fa": "عکس نویسنده‌ی کامنت حالا کاملاً کنار حباب قرار می‌گیرد و گوشه‌اش با حباب هماهنگ است تا عکس و حباب به هم چسبیده دیده شوند؛ در چیپ‌های ری‌اکشن هم اول عکس‌ها و بعد اموجی می‌آید"
        },
        {
          "area": "comments",
          "phases": [
            "P09"
          ],
          "en": "React to comments with emoji: hover a comment on desktop (or tap it on phones) for the emoji button; reactions show under the comment with the photos of who reacted, and clicking one adds or removes yours",
          "fa": "واکنش با اموجی روی کامنت‌ها: در دسکتاپ با هاور روی کامنت (و در موبایل با لمس آن) دکمه‌ی اموجی می‌آید؛ واکنش‌ها با عکس کسانی که واکنش داده‌اند زیر کامنت نمایش داده می‌شوند و با کلیک روی هرکدام، واکنش خودتان اضافه یا حذف می‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P09"
          ],
          "en": "Links in comments can be copied with a click, just like links in task notes",
          "fa": "لینک‌های داخل کامنت هم مثل لینک‌های یادداشت تسک با یک کلیک کپی می‌شوند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "In shared projects, the open task shows the creator’s photo at the end of the title line; click it to see who created the task and when",
          "fa": "در پروژه‌های اشتراکی، تسک باز عکس سازنده را در انتهای خط عنوان نشان می‌دهد؛ با کلیک روی آن، سازنده و زمان ساخت دیده می‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P09"
          ],
          "en": "Closed task rows always show the comment count, in wide columns too",
          "fa": "ردیف بسته‌ی تسک همیشه تعداد کامنت‌ها را نشان می‌دهد، در ستون‌های پهن هم"
        },
        {
          "area": "comments",
          "phases": [
            "P09"
          ],
          "en": "Done and trashed tasks open like normal tasks: click a row under “Show logged items” or “Show trashed items” and the full task card opens in its list; a trashed task shows an In Trash bar with Restore. Opening one from Notifications, Mentions or My activity does the same; a trashed task is read-only until it is restored",
          "fa": "تسک‌های دان‌شده و داخل سطل زباله مثل تسک‌های عادی باز می‌شوند: با کلیک روی ردیف در Show logged items یا Show trashed items، کارت کامل تسک در لیست خودش باز می‌شود؛ تسک داخل سطل زباله نوار In Trash با دکمه‌ی Restore دارد. باز کردن آن‌ها از Notifications، Mentions یا My activity هم همین‌طور است؛ تسکِ داخل سطل زباله تا وقتی بازگردانده نشود فقط‌خواندنی است"
        },
        {
          "area": "menu",
          "phases": [
            "P09"
          ],
          "en": "Clicking a project in the Projects menu jumps to its first open column (or opens it if none); + opens it in a new column",
          "fa": "کلیک روی پروژه در منوی پروژه‌ها به اولین ستون باز آن می‌رود (اگر بازی نبود، بازش می‌کند)؛ دکمه‌ی + آن را در ستون جدید باز می‌کند"
        },
        {
          "area": "sync",
          "phases": [
            "P09"
          ],
          "en": "The collapsed Projects bar shows the connection status: a status dot when online, a red no-wifi icon when offline",
          "fa": "نوار بسته‌ی پروژه‌ها وضعیت اتصال را نشان می‌دهد: در حالت آنلاین یک نقطه‌ی وضعیت و در حالت آفلاین آیکن قرمز قطع وای‌فای"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "(desktop) Pressing Enter in the notes of the last task in a list closes it and moves the cursor to + New task",
          "fa": "(دسکتاپ) Enter در یادداشت آخرین تسک یک لیست، تسک را می‌بندد و نشانگر را به + New task می‌برد"
        },
        {
          "area": "ix",
          "phases": [
            "P09"
          ],
          "en": "(desktop) Move through tasks with ↑ / ↓ and open the highlighted one with Enter; the + New task box of each list is part of the path; Shift+↑/↓ adds to the selection",
          "fa": "(دسکتاپ) حرکت بین تسک‌ها با ↑ / ↓ و باز کردن تسک انتخاب‌شده با Enter؛ کادر + New task هر لیست هم در مسیر حرکت است؛ Shift+↑/↓ به انتخاب اضافه می‌کند"
        }
      ]
    },
    {
      "version": "10.5",
      "status": "released",
      "date": "2026-10-16",
      "items": [
        {
          "area": "app",
          "phases": [
            "P09"
          ],
          "en": "Every letter you type is kept, even while colleagues' changes are arriving",
          "fa": "هر حرفی که تایپ می‌کنید حفظ می‌شود، حتی وقتی تغییرات همکاران در حال رسیدن است"
        },
        {
          "area": "app",
          "phases": [
            "P19"
          ],
          "en": "Typing stays fast in big projects: only the rows that changed are redrawn",
          "fa": "تایپ در پروژه‌های بزرگ هم سریع می‌ماند: فقط ردیف‌هایی که تغییر کرده‌اند دوباره کشیده می‌شوند"
        }
      ]
    },
    {
      "version": "10.4",
      "status": "released",
      "date": "2026-10-15",
      "items": [
        {
          "area": "app",
          "phases": [
            "P14"
          ],
          "en": "Typing stays smooth: saving each edit no longer reloads your invites, trash, preferences and layout every time",
          "fa": "تایپ روان می‌ماند: ذخیره‌ی هر ویرایش دیگر هر بار دعوت‌ها، سطل زباله، تنظیمات و چیدمان را دوباره بارگیری نمی‌کند"
        }
      ]
    },
    {
      "version": "10.3",
      "status": "released",
      "date": "2026-10-15",
      "items": [
        {
          "area": "app",
          "phases": [
            "P08"
          ],
          "en": "The app stays fast while it syncs: the status no longer flickers to “Syncing” for routine updates, and your devices no longer pass the same column layout back and forth",
          "fa": "برنامه هنگام همگام‌سازی کند نمی‌شود: وضعیت برای به‌روزرسانی‌های عادی دیگر مدام «Syncing» نمی‌شود و دستگاه‌هایتان دیگر چیدمان ستون‌ها را مدام برای هم نمی‌فرستند"
        },
        {
          "area": "look",
          "phases": [
            "P15"
          ],
          "en": "The London theme and its red accent now save to your account",
          "fa": "تم London و رنگ قرمزش حالا در حساب شما ذخیره می‌شود"
        }
      ]
    },
    {
      "version": "10.2",
      "status": "released",
      "date": "2026-10-15",
      "items": [
        {
          "area": "app",
          "phases": [
            "P06"
          ],
          "en": "Offline, the “You’re offline” banner stays put instead of popping up again with every edit",
          "fa": "در حالت آفلاین، نوار «آفلاین هستید» ثابت می‌ماند و دیگر با هر تغییر دوباره ظاهر نمی‌شود"
        },
        {
          "area": "layout",
          "phases": [
            "P19"
          ],
          "en": "Safari: filter chips no longer overlap",
          "fa": "سافاری: دکمه‌های فیلتر دیگر روی هم نمی‌افتند"
        }
      ]
    },
    {
      "version": "10.1",
      "status": "released",
      "date": "2026-10-14",
      "items": [
        {
          "area": "layout",
          "phases": [
            "P08"
          ],
          "en": "A task open in one column stays open when you open a task in another column",
          "fa": "تسکی که در یک ستون باز است، با باز کردن تسک در ستون دیگر بسته نمی‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "Project comments can include images too: paste one into the comment box",
          "fa": "کامنت‌های پروژه هم می‌توانند عکس داشته باشند: عکس را در باکس کامنت پیست کنید"
        }
      ]
    },
    {
      "version": "10.0",
      "status": "released",
      "date": "2026-10-14",
      "highlights": [
        {
          "en": "New dark theme London, with a bus-red accent",
          "fa": "تم تیره‌ی جدید London با اکسنت قرمز اتوبوس."
        },
        {
          "en": "Keyboard flow through an open task: Enter moves from the title to tags and people, then to notes, and Enter in notes closes the task; the tag dropdown opens only when you type",
          "fa": "جریان کیبورد در تسک باز: اینتر از عنوان به تگ و افراد، بعد به یادداشت می‌رود و اینتر در یادداشت تسک را می‌بندد؛ دراپ‌داون تگ فقط با تایپ باز می‌شود."
        },
        {
          "en": "On phones, tags and people are picked from a bottom sheet that shows everything and toggles with a tap",
          "fa": "در موبایل، تگ و افراد از یک باتم‌شیت انتخاب می‌شوند که همه‌چیز را نشان می‌دهد و با لمس روشن/خاموش می‌شود."
        },
        {
          "en": "Tags and assignees follow the order set in Project settings",
          "fa": "تگ‌ها و اساینی‌ها به ترتیب تنظیمات پروژه نمایش داده می‌شوند."
        },
        {
          "en": "On phones, no pull-to-refresh and no accidental back swipe",
          "fa": "در موبایل، کشیدن به پایین رفرش نمی‌کند و کشیدن از لبه به عقب نمی‌رود."
        }
      ],
      "items": [
        {
          "area": "desk",
          "phases": [
            "P07"
          ],
          "en": "Multi-desktop: keep several separate column layouts and switch between them from the Desktops button next to Full screen",
          "fa": "مولتی‌دسکتاپ: چند چیدمان ستون جدا داشته باشید و از دکمه‌ی Desktops کنار Full screen بینشان جابه‌جا شوید"
        },
        {
          "area": "desk",
          "phases": [
            "P07"
          ],
          "en": "Desktops: switch quickly with ⌃1–9",
          "fa": "جابه‌جایی سریع بین دسکتاپ‌ها با ⌃1–9"
        },
        {
          "area": "desk",
          "phases": [
            "P07"
          ],
          "en": "Desktops: create an empty desktop or duplicate the current one with all its columns",
          "fa": "ساخت دسکتاپ خالی یا کپی دسکتاپ فعلی با همه‌ی ستون‌هایش"
        },
        {
          "area": "desk",
          "phases": [
            "P07"
          ],
          "en": "Desktops: rename with the pencil or a double-click; the column count shows next to each name",
          "fa": "تغییر نام با مداد یا دابل‌کلیک؛ تعداد ستون‌ها کنار اسم هر دسکتاپ نمایش داده می‌شود"
        },
        {
          "area": "desk",
          "phases": [
            "P07"
          ],
          "en": "Desktops: drag to reorder; delete with confirmation",
          "fa": "تغییر ترتیب با کشیدن؛ حذف با تأیید"
        },
        {
          "area": "desk",
          "phases": [
            "P07"
          ],
          "en": "Desktops: the current desktop is marked with an accent tint and edge line instead of a check mark",
          "fa": "دسکتاپ فعلی به‌جای تیک، با پس‌زمینه‌ی کم‌رنگ و خط اکسنت لبه مشخص می‌شود"
        },
        {
          "area": "desk",
          "phases": [
            "P07"
          ],
          "en": "Desktops: each desktop can have its own theme, or Auto to follow the app theme; while renaming the current desktop, a labelled theme picker opens below it",
          "fa": "هر دسکتاپ می‌تواند تم خودش را داشته باشد یا روی Auto بماند تا از تم اپ پیروی کند؛ هنگام ادیت اسم دسکتاپ فعلی، انتخاب‌گر تم با اسم‌ها زیر آن باز می‌شود"
        },
        {
          "area": "projects",
          "phases": [
            "P07"
          ],
          "en": "Each project can have its own accent colour (Project settings › Accent): only that project’s columns use it, the background stays the same; a thick accent bar marks the top of its header, and its icon in the Projects list takes the colour too",
          "fa": "هر پروژه می‌تواند رنگ اکسنت خودش را داشته باشد (تنظیمات پروژه › Accent): فقط ستون‌های همان پروژه این رنگ را می‌گیرند و پس‌زمینه تغییر نمی‌کند؛ یک نوار کلفت به رنگ اکسنت بالای هدر پروژه می‌آید و آیکن پروژه در لیست پروژه‌ها هم همین رنگ را می‌گیرد"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Text between triple backticks (```) in a task’s notes shows as a copy box, like in Telegram; click the box to copy its text, click anywhere else in the notes to edit them",
          "fa": "متنی که در یادداشت تسک بین سه بک‌تیک (```) باشد، مثل تلگرام به‌صورت یک باکس کپی نمایش داده می‌شود؛ با کلیک روی باکس متنش کپی می‌شود و با کلیک روی بقیه‌ی یادداشت، ویرایش باز می‌شود"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "In a task’s notes, click a link to copy it; hovering a link turns the pointer into a hand and shows a small hint above it",
          "fa": "در یادداشت تسک با کلیک روی لینک، لینک کپی می‌شود؛ با هاور روی لینک، نشانگر دست می‌شود و یک راهنمای کوچک بالای آن می‌آید"
        },
        {
          "area": "comments",
          "phases": [
            "P07"
          ],
          "en": "Reply to a comment: double-click it, or right-click (long-press on phones) and choose Reply; the reply shows a quote of the original, which jumps back to it when clicked",
          "fa": "ریپلای به کامنت: با دابل‌کلیک، یا راست‌کلیک (نگه داشتن در موبایل) و انتخاب Reply؛ ریپلای یک نقل‌قول از کامنت اصلی دارد که با کلیک به همان کامنت می‌رود"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "When a column is filtered by a tag, each task row shows its other tags first, in your tag order, and the filtered tag last",
          "fa": "وقتی ستون روی یک تگ فیلتر شده، هر تسک اول تگ‌های دیگرش را به ترتیب دلخواه شما نشان می‌دهد و تگ فیلترشده را آخر"
        },
        {
          "area": "tasks",
          "phases": [
            "P07"
          ],
          "en": "A tag that no task uses any more is removed from the project",
          "fa": "تگی که دیگر هیچ تسکی آن را ندارد، از پروژه حذف می‌شود"
        },
        {
          "area": "sharing",
          "phases": [
            "P07"
          ],
          "en": "Project team page: members and the invite area are separate sections; the list fills the sheet down to its bottom edge; filter tabs All, Team, Invited and Suggested each show a count; the settings sheet keeps one fixed, shorter height",
          "fa": "صفحه‌ی تیم پروژه: اعضا و بخش دعوت دو قسمت جدا هستند؛ لیست تا لبه‌ی پایین باتم‌شیت می‌رود؛ تب‌های فیلتر All، Team، Invited و Suggested هر کدام تعدادشان را نشان می‌دهند؛ باتم‌شیت تنظیمات یک ارتفاع ثابت و کوتاه‌تر دارد"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "The column filter dropdown and the task’s tag & person picker now look alike: every item is listed, selected or not, each with an icon for tag, person or list, and selected ones are filled chips",
          "fa": "دراپ‌داون فیلتر بالای ستون و انتخاب‌گر تگ و فرد در تسک حالا شبیه هم هستند: همه‌ی موارد، انتخاب‌شده یا نشده، با آیکن تگ، فرد یا لیست نمایش داده می‌شوند و موارد انتخاب‌شده چیپ پر هستند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "The filter row only shows people who have open tasks assigned to them",
          "fa": "ردیف فیلتر بالای ستون فقط افرادی را نشان می‌دهد که تسک باز به آن‌ها اساین شده"
        },
        {
          "area": "comments",
          "phases": [
            "P07"
          ],
          "en": "Comments can include images: paste one into the comment box; images show inside the comment and open full screen",
          "fa": "کامنت‌ها می‌توانند تصویر داشته باشند: با پیست در باکس کامنت؛ تصویرها داخل کامنت نمایش داده می‌شوند و تمام‌صفحه باز می‌شوند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Tags next to a closed task’s title are now vertically centred on the title line, at every density",
          "fa": "تگ‌های کنار عنوان تسک بسته حالا دقیقاً با خط عنوان هم‌تراز هستند، در همه‌ی حالت‌های Density"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Dropping a task into a column of another project that is filtered by a tag now reliably adds that tag (and the filtered person), wherever in the column you drop it",
          "fa": "رها کردن تسک در ستونِ پروژه‌ی دیگری که روی یک تگ فیلتر شده، حالا همیشه همان تگ (و فرد فیلترشده) را به تسک اضافه می‌کند، هر جای ستون که رها شود"
        },
        {
          "area": "sharing",
          "phases": [
            "P07"
          ],
          "en": "Adding a team member suggests people from your other projects, filtered as you type, with a one-click Invite",
          "fa": "هنگام اضافه کردن عضو تیم، افراد پروژه‌های دیگرتان پیشنهاد می‌شوند، با تایپ فیلتر می‌شوند و با یک کلیک دعوت می‌شوند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "When a column is filtered to one list, the New list button is hidden",
          "fa": "وقتی ستون روی یک لیست فیلتر شده، دکمه‌ی لیست جدید نمایش داده نمی‌شود"
        },
        {
          "area": "app",
          "phases": [
            "P07"
          ],
          "en": "The Projects column title now reads TaskCool",
          "fa": "عنوان ستون پروژه‌ها حالا TaskCool است"
        },
        {
          "area": "app",
          "phases": [
            "P07"
          ],
          "en": "Connection status above your profile in the Projects menu: Online with changes saved to the cloud, or Offline with changes kept on this device and synced when the connection returns; while offline, a red banner stays at the top of the screen",
          "fa": "وضعیت اتصال بالای پروفایل در منوی پروژه‌ها: آنلاین با ذخیره‌ی مستقیم تغییرات در کلاد، یا آفلاین با نگه‌داری تغییرات روی همین دستگاه و همگام‌سازی پس از برگشت اینترنت؛ در حالت آفلاین یک نوار قرمز بالای صفحه می‌ماند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Each column keeps its own open task and bottom sheet: opening a task or sheet in one column no longer closes the one in another",
          "fa": "هر ستون تسک باز و باتم‌شیت خودش را نگه می‌دارد: باز کردن تسک یا باتم‌شیت در یک ستون، مورد باز در ستون دیگر را نمی‌بندد"
        },
        {
          "area": "comments",
          "phases": [
            "P07"
          ],
          "en": "Comments: the comment and change counts show as icons with numbers; the top fade appears only when older comments are scrolled out of view, and the gap above the first comment is smaller",
          "fa": "کامنت‌ها: تعداد کامنت‌ها و تغییرات به‌صورت آیکن و عدد نمایش داده می‌شود؛ محو شدن بالای لیست فقط وقتی کامنت‌های قدیمی‌تر بیرون از دید هستند دیده می‌شود و فاصله‌ی بالای اولین کامنت کمتر شده"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Tag & person picker lists everyone and every tag in one list, in your sort order; the ones on the task show as chips, like on the task, and clicking toggles them",
          "fa": "انتخاب‌گر تگ و افراد همه‌ی افراد و تگ‌ها را در یک لیست و به ترتیب سورت شما نشان می‌دهد؛ موارد روی تسک مثل چیپ‌های خود تسک دیده می‌شوند و با کلیک روشن یا خاموش می‌شوند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Emoji picker: emoji stay still and only the one under the pointer animates, in place; the picker opens above everything, closes when the pointer leaves it, and no longer shows a tooltip; the emoji button is always there and Send appears once you type",
          "fa": "انتخاب‌گر اموجی: اموجی‌ها ثابت‌اند و فقط اموجی زیر نشانگر، همان‌جا متحرک می‌شود؛ انتخاب‌گر روی همه‌چیز باز می‌شود، با خارج شدن نشانگر بسته می‌شود و دیگر تول‌تیپ نشان نمی‌دهد؛ دکمه‌ی اموجی همیشه هست و دکمه‌ی ارسال با شروع تایپ ظاهر می‌شود"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Image and File are now one Attach button in the task bar; images go to the task’s images and other files to attachments",
          "fa": "تصویر و فایل در نوار تسک یک دکمه‌ی Attach شدند؛ عکس‌ها به عکس‌های تسک و بقیه‌ی فایل‌ها به پیوست‌ها می‌روند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Typing in “+ New task” (desktop) creates the task right away and opens it, with the cursor in its title, so Enter carries on to tags, notes and closing",
          "fa": "تایپ کردن در «+ New task» (دسکتاپ) همان لحظه تسک را می‌سازد و بازش می‌کند و نشانگر در عنوان آن می‌ماند، پس با اینتر به تگ، یادداشت و بستن می‌روید"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Delete (or Backspace) moves the selected task, or all selected tasks, to Trash; Undo brings them back",
          "fa": "کلید Delete (یا Backspace) تسک انتخاب‌شده یا همه‌ی تسک‌های انتخاب‌شده را به سطل زباله می‌برد؛ با Undo برمی‌گردند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "↑ / ↓ move between the fields of an open task (desktop): ↓ from the end of the title goes to tags and people, then to the notes; ↑ from an empty tag/person box goes back to the title, and from the start of the notes back to tags and people",
          "fa": "کلیدهای ↑ / ↓ بین فیلدهای تسک باز جابه‌جا می‌شوند (دسکتاپ): ↓ از انتهای عنوان به تگ و افراد و بعد به یادداشت می‌رود؛ ↑ از باکس خالی تگ و افراد به عنوان و از ابتدای یادداشت به تگ و افراد برمی‌گردد"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Notes (desktop): Shift+Enter adds a new line, and Enter saves and closes the task",
          "fa": "یادداشت (دسکتاپ): Shift+Enter به خط بعد می‌رود و Enter ذخیره می‌کند و تسک را می‌بندد"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Adding a tag or person (desktop): clicking the box opens the dropdown; reaching it with the keyboard keeps it closed until you type, and it closes again after each pick so you can type the next one",
          "fa": "اضافه کردن تگ یا فرد (دسکتاپ): کلیک روی باکس دراپ‌داون را باز می‌کند؛ اگر با کیبورد به آن برسید تا وقتی تایپ نکنید بسته می‌ماند و بعد از هر انتخاب بسته می‌شود تا مورد بعدی را تایپ کنید"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Keyboard flow in an open task: Enter in the title moves to the tag/person box, and Enter in an empty tag/person box moves on to the notes",
          "fa": "جریان کیبورد در تسک باز: اینتر در عنوان به باکس تگ/فرد می‌رود و اینتر در باکس خالی تگ/فرد به یادداشت می‌رود"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Phone tag/person sheet: items toggle only on a real tap, so scrolling the list no longer selects anything; selected items show as filled chips",
          "fa": "باتم‌شیت تگ/فرد در موبایل: موارد فقط با لمس واقعی انتخاب می‌شوند، پس اسکرول کردن لیست چیزی را انتخاب نمی‌کند؛ موارد انتخاب‌شده به‌صورت چیپ پر نمایش داده می‌شوند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "Phone tag/person sheet opens above everything, including the side columns’ edge tabs, with a dimmed backdrop that closes it",
          "fa": "باتم‌شیت تگ/فرد در موبایل روی همه‌چیز، حتی لبه‌ی ستون‌های کناری، باز می‌شود و پس‌زمینه‌ی تیره‌اش با لمس آن را می‌بندد"
        },
        {
          "area": "tasks",
          "phases": [
            "P07"
          ],
          "en": "Tags and assignees on tasks and in the add menu follow the order set in Project settings",
          "fa": "تگ‌ها و اساینی‌های تسک و منوی اضافه کردن، به ترتیبی که در تنظیمات پروژه چیده‌اید نمایش داده می‌شوند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "On phones, adding a tag or person to a task opens a bottom sheet with a filter box, without opening the keyboard; it lists every person and tag, marks the ones already on the task, and tapping toggles them while the sheet stays open",
          "fa": "در موبایل، اضافه کردن تگ یا فرد به تسک یک باتم‌شیت با فیلتر باز می‌کند، بدون اینکه کیبورد باز شود؛ همه‌ی افراد و تگ‌ها در آن هستند، موارد انتخاب‌شده مشخص‌اند و با لمس، روشن یا خاموش می‌شوند و شیت باز می‌ماند"
        },
        {
          "area": "ix",
          "phases": [
            "P07"
          ],
          "en": "On phones, pulling down no longer refreshes the page, and swiping from the screen edge no longer goes back out of the app",
          "fa": "در موبایل، کشیدن صفحه به پایین دیگر صفحه را رفرش نمی‌کند و کشیدن از لبه‌ی صفحه دیگر از اپ خارج نمی‌شود"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "New dark theme London: Underground navy, Portland-stone text and a bus-red accent, which is set automatically when you pick the theme (bus red is also added to the accent swatches)",
          "fa": "تم تیره‌ی جدید London: سرمه‌ای متروی لندن، متن به رنگ سنگ پورتلند و اکسنت قرمز اتوبوس که با انتخاب تم خودکار تنظیم می‌شود (قرمز اتوبوس به رنگ‌های اکسنت هم اضافه شد)"
        }
      ],
      "doc_fa": {
        "overview": [
          {
            "parts": [
              {
                "text": "نسخهٔ ۱۰ با ",
                "b": false
              },
              {
                "text": "چند دسکتاپ مستقل",
                "b": true
              },
              {
                "text": "، مدیریت سریع‌تر تسک‌ها با کیبورد و تعامل‌های بهتر در موبایل، امکانات بیشتری برای سازمان‌دهی کارها فراهم می‌کند. انتخاب تگ‌ها و افراد یکپارچه‌تر شده، کامنت‌ها از تصویر و ریپلای پشتیبانی می‌کنند و دعوت اعضای تیم ساده‌تر شده است. تم جدید ",
                "b": false
              },
              {
                "text": "London",
                "b": true
              },
              {
                "text": "، رنگ اختصاصی پروژه‌ها و نمایش وضعیت اتصال و همگام‌سازی نیز از تغییرات این نسخه هستند.",
                "b": false
              }
            ]
          },
          {
            "parts": [
              {
                "text": "تغییرات زیر بر اساس قابلیت دسته‌بندی شده‌اند و قابلیت‌های اصلی و تغییرات مؤثرتر بر کار روزمره، در ابتدا آمده‌اند.",
                "b": false
              }
            ]
          }
        ],
        "sections": [
          {
            "title": "۱. چند دسکتاپ مستقل — Multi-desktop",
            "intro": "برای چیدمان‌های مختلف کاری، چند دسکتاپ با ستون‌های جداگانه بسازید و سریع بین آن‌ها جابه‌جا شوید.",
            "items": [
              {
                "parts": [
                  {
                    "text": "چند چیدمان مستقل:",
                    "b": true
                  },
                  {
                    "text": " از دکمهٔ ",
                    "b": false
                  },
                  {
                    "text": "Desktops",
                    "b": true
                  },
                  {
                    "text": " کنار ",
                    "b": false
                  },
                  {
                    "text": "Full screen",
                    "b": true
                  },
                  {
                    "text": " برای جابه‌جایی بین دسکتاپ‌ها استفاده کنید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "ساخت یا کپی دسکتاپ:",
                    "b": true
                  },
                  {
                    "text": " یک دسکتاپ خالی بسازید یا دسکتاپ فعلی را همراه با تمام ستون‌هایش کپی کنید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "جابه‌جایی سریع با کیبورد:",
                    "b": true
                  },
                  {
                    "text": " با میان‌بر ",
                    "b": false
                  },
                  {
                    "text": "⌃1–9",
                    "b": true
                  },
                  {
                    "text": " بین دسکتاپ‌ها جابه‌جا شوید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "تم اختصاصی برای هر دسکتاپ:",
                    "b": true
                  },
                  {
                    "text": " هر دسکتاپ می‌تواند تم خودش را داشته باشد یا روی ",
                    "b": false
                  },
                  {
                    "text": "Auto",
                    "b": true
                  },
                  {
                    "text": " بماند تا از تم اپ پیروی کند. هنگام ویرایش نام دسکتاپ فعلی، انتخاب‌گر تم همراه با نام تم‌ها زیر آن باز می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "مدیریت دسکتاپ‌ها:",
                    "b": true
                  },
                  {
                    "text": " ترتیب دسکتاپ‌ها را با کشیدن تغییر دهید؛ حذف دسکتاپ با تأیید انجام می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "تغییر نام و نمایش تعداد ستون‌ها:",
                    "b": true
                  },
                  {
                    "text": " نام دسکتاپ با دکمهٔ مداد یا دابل‌کلیک قابل ویرایش است و تعداد ستون‌ها کنار نام هر دسکتاپ نمایش داده می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "تشخیص دسکتاپ فعلی:",
                    "b": true
                  },
                  {
                    "text": " دسکتاپ فعال به‌جای تیک، با پس‌زمینهٔ کم‌رنگ و یک خط اکسنت در لبه مشخص می‌شود.",
                    "b": false
                  }
                ]
              }
            ]
          },
          {
            "title": "۲. ساخت، ویرایش و مدیریت سریع‌تر تسک‌ها",
            "intro": "جریان کار با کیبورد در دسکتاپ روان‌تر شده و هر ستون وضعیت تسک باز خودش را حفظ می‌کند.",
            "items": [
              {
                "parts": [
                  {
                    "text": "ساخت فوری تسک در دسکتاپ:",
                    "b": true
                  },
                  {
                    "text": " تایپ در ",
                    "b": false
                  },
                  {
                    "text": "+ New task",
                    "b": true
                  },
                  {
                    "text": " همان لحظه تسک را می‌سازد و باز می‌کند؛ نشانگر در عنوان باقی می‌ماند تا بتوانید با Enter به بخش تگ و افراد، سپس یادداشت و در نهایت ذخیره و بستن تسک بروید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "حرکت با Enter در تسک باز:",
                    "b": true
                  },
                  {
                    "text": " Enter در عنوان، نشانگر را به کادر تگ و افراد می‌برد؛ Enter در کادر خالی تگ و افراد، نشانگر را به یادداشت منتقل می‌کند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "ذخیرهٔ یادداشت با کیبورد در دسکتاپ:",
                    "b": true
                  },
                  {
                    "text": " ",
                    "b": false
                  },
                  {
                    "text": "Shift+Enter",
                    "b": true
                  },
                  {
                    "text": " خط جدید می‌سازد و ",
                    "b": false
                  },
                  {
                    "text": "Enter",
                    "b": true
                  },
                  {
                    "text": " یادداشت را ذخیره می‌کند و تسک را می‌بندد.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "حرکت بین فیلدها با ↑ و ↓ در دسکتاپ:",
                    "b": true
                  }
                ],
                "subs": [
                  {
                    "parts": [
                      {
                        "text": "↓",
                        "b": true
                      },
                      {
                        "text": " از انتهای عنوان به تگ و افراد و سپس به یادداشت می‌رود.",
                        "b": false
                      }
                    ]
                  },
                  {
                    "parts": [
                      {
                        "text": "↑",
                        "b": true
                      },
                      {
                        "text": " از کادر خالی تگ و افراد به عنوان برمی‌گردد و از ابتدای یادداشت به تگ و افراد می‌رود.",
                        "b": false
                      }
                    ]
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "حذف تسک‌های انتخاب‌شده:",
                    "b": true
                  },
                  {
                    "text": " کلید ",
                    "b": false
                  },
                  {
                    "text": "Delete",
                    "b": true
                  },
                  {
                    "text": " یا ",
                    "b": false
                  },
                  {
                    "text": "Backspace",
                    "b": true
                  },
                  {
                    "text": " یک تسک یا همهٔ تسک‌های انتخاب‌شده را به سطل زباله منتقل می‌کند. با ",
                    "b": false
                  },
                  {
                    "text": "Undo",
                    "b": true
                  },
                  {
                    "text": " می‌توانید آن‌ها را برگردانید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "حفظ وضعیت مستقل ستون‌ها:",
                    "b": true
                  },
                  {
                    "text": " هر ستون، تسک باز و باتم‌شیت خودش را نگه می‌دارد؛ باز کردن تسک یا باتم‌شیت در یک ستون، مورد باز در ستون دیگر را نمی‌بندد.",
                    "b": false
                  }
                ]
              }
            ]
          },
          {
            "title": "۳. تگ‌ها، افراد و فیلترهای ستون",
            "intro": "نمایش و انتخاب تگ‌ها و افراد هماهنگ‌تر شده و ترتیب دلخواه پروژه در بخش‌های مختلف رعایت می‌شود.",
            "items": [
              {
                "parts": [
                  {
                    "text": "رعایت ترتیب تنظیم‌شده در پروژه:",
                    "b": true
                  },
                  {
                    "text": " تگ‌ها و افراد اختصاص‌یافته به تسک، همچنین موارد منوی افزودن، به ترتیبی نمایش داده می‌شوند که در تنظیمات پروژه چیده‌اید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "انتخاب‌گر یکپارچهٔ تگ و افراد:",
                    "b": true
                  },
                  {
                    "text": " همهٔ تگ‌ها و افراد در یک لیست و مطابق ترتیب دلخواه شما نمایش داده می‌شوند. موارد موجود روی تسک، مانند چیپ‌های خود تسک دیده می‌شوند و با کلیک می‌توان آن‌ها را انتخاب یا از انتخاب خارج کرد.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "رفتار انتخاب‌گر در دسکتاپ:",
                    "b": true
                  },
                  {
                    "text": " کلیک روی کادر، دراپ‌داون را باز می‌کند. اگر با کیبورد به کادر برسید، دراپ‌داون تا شروع تایپ بسته می‌ماند. بعد از هر انتخاب نیز بسته می‌شود تا بتوانید مورد بعدی را تایپ کنید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "هماهنگی ظاهر فیلتر و انتخاب‌گر:",
                    "b": true
                  },
                  {
                    "text": " دراپ‌داون فیلتر بالای ستون و انتخاب‌گر تگ و افراد در تسک، ظاهر مشابهی دارند. همهٔ موارد، چه انتخاب‌شده و چه انتخاب‌نشده، با آیکن تگ، فرد یا لیست نمایش داده می‌شوند؛ موارد انتخاب‌شده به‌شکل چیپ پر هستند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نمایش افراد در ردیف فیلتر:",
                    "b": true
                  },
                  {
                    "text": " ردیف فیلتر بالای ستون فقط افرادی را نشان می‌دهد که تسک باز به آن‌ها اختصاص داده شده است.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "ترتیب تگ‌ها در ستون فیلترشده:",
                    "b": true
                  },
                  {
                    "text": " وقتی ستون روی یک تگ فیلتر شده، ابتدا تگ‌های دیگر هر تسک با ترتیب دلخواه شما نمایش داده می‌شوند و تگ فیلترشده در انتها قرار می‌گیرد.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "اعمال فیلتر هنگام انتقال تسک:",
                    "b": true
                  },
                  {
                    "text": " اگر تسک را در ستونِ پروژهٔ دیگری رها کنید که روی یک تگ فیلتر شده، همان تگ و فرد فیلترشده همیشه به تسک اضافه می‌شوند؛ محل رها کردن تسک در ستون تفاوتی ندارد.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نمایش دکمهٔ لیست جدید:",
                    "b": true
                  },
                  {
                    "text": " وقتی ستون روی یک لیست فیلتر شده، دکمهٔ ساخت لیست جدید نمایش داده نمی‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "پاک‌سازی تگ‌های بدون استفاده:",
                    "b": true
                  },
                  {
                    "text": " تگی که دیگر روی هیچ تسکی وجود ندارد، از پروژه حذف می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "هم‌ترازی تگ‌ها با عنوان:",
                    "b": true
                  },
                  {
                    "text": " تگ‌های کنار عنوان تسک بسته، در تمام حالت‌های ",
                    "b": false
                  },
                  {
                    "text": "Density",
                    "b": true
                  },
                  {
                    "text": " دقیقاً با خط عنوان هم‌تراز هستند.",
                    "b": false
                  }
                ]
              }
            ]
          },
          {
            "title": "۴. تجربهٔ بهتر در موبایل",
            "intro": "انتخاب تگ و افراد در موبایل ساده‌تر شده و حرکت‌های لمسی ناخواسته، اختلال کمتری در کار ایجاد می‌کنند.",
            "items": [
              {
                "parts": [
                  {
                    "text": "انتخاب تگ و افراد با باتم‌شیت:",
                    "b": true
                  },
                  {
                    "text": " افزودن تگ یا فرد به تسک، یک باتم‌شیت دارای فیلتر باز می‌کند، بدون اینکه کیبورد باز شود. همهٔ افراد و تگ‌ها در آن حضور دارند، موارد انتخاب‌شده مشخص‌اند و با لمس می‌توان آن‌ها را انتخاب یا از انتخاب خارج کرد؛ شیت پس از انتخاب باز می‌ماند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نمایش انتخاب‌ها:",
                    "b": true
                  },
                  {
                    "text": " موارد انتخاب‌شده در باتم‌شیت به‌شکل چیپ پر نمایش داده می‌شوند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "جلوگیری از انتخاب هنگام اسکرول:",
                    "b": true
                  },
                  {
                    "text": " موارد فقط با لمس واقعی انتخاب می‌شوند؛ اسکرول کردن لیست باعث انتخاب ناخواستهٔ آن‌ها نمی‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نمایش باتم‌شیت روی تمام محتوا:",
                    "b": true
                  },
                  {
                    "text": " باتم‌شیت تگ و افراد روی همه‌چیز، حتی لبهٔ ستون‌های کناری، باز می‌شود. لمس پس‌زمینهٔ تیره، آن را می‌بندد.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "جلوگیری از رفرش یا خروج ناخواسته:",
                    "b": true
                  },
                  {
                    "text": " کشیدن صفحه به پایین دیگر صفحه را رفرش نمی‌کند و کشیدن از لبهٔ صفحه نیز باعث خروج از اپ نمی‌شود.",
                    "b": false
                  }
                ]
              }
            ]
          },
          {
            "title": "۵. یادداشت‌ها، فایل‌ها و انتخاب‌گر اموجی",
            "intro": "کار با محتوای تسک، پیوست‌ها و متن‌های قابل کپی آسان‌تر شده است.",
            "items": [
              {
                "parts": [
                  {
                    "text": "دکمهٔ یکپارچهٔ Attach:",
                    "b": true
                  },
                  {
                    "text": " دکمه‌های تصویر و فایل در نوار تسک، در یک دکمهٔ ",
                    "b": false
                  },
                  {
                    "text": "Attach",
                    "b": true
                  },
                  {
                    "text": " ادغام شده‌اند. عکس‌ها به بخش عکس‌های تسک و سایر فایل‌ها به بخش پیوست‌ها می‌روند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "کپی لینک از یادداشت:",
                    "b": true
                  },
                  {
                    "text": " کلیک روی لینک در یادداشت تسک، آن را کپی می‌کند. هنگام قرار گرفتن نشانگر روی لینک، نشانگر به‌شکل دست درمی‌آید و یک راهنمای کوچک بالای لینک نمایش داده می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "باکس متن قابل کپی:",
                    "b": true
                  },
                  {
                    "text": " متنی که در یادداشت میان سه بک‌تیک (` ``` `) قرار بگیرد، مانند تلگرام به‌شکل یک باکس قابل کپی نمایش داده می‌شود. کلیک روی باکس، متن آن را کپی می‌کند و کلیک روی سایر بخش‌های یادداشت، ویرایش را باز می‌کند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "انتخاب‌گر اموجی:",
                    "b": true
                  }
                ],
                "subs": [
                  {
                    "parts": [
                      {
                        "text": "اموجی‌ها ثابت‌اند و فقط اموجی زیر نشانگر، در همان محل متحرک می‌شود.",
                        "b": false
                      }
                    ]
                  },
                  {
                    "parts": [
                      {
                        "text": "انتخاب‌گر روی تمام محتوا باز می‌شود و با خروج نشانگر بسته می‌شود.",
                        "b": false
                      }
                    ]
                  },
                  {
                    "parts": [
                      {
                        "text": "تول‌تیپ دیگر نمایش داده نمی‌شود.",
                        "b": false
                      }
                    ]
                  },
                  {
                    "parts": [
                      {
                        "text": "دکمهٔ اموجی همیشه در دسترس است و دکمهٔ ارسال با شروع تایپ ظاهر می‌شود.",
                        "b": false
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "title": "۶. کامنت‌ها و ریپلای",
            "intro": "کامنت‌ها اکنون از تصویر و پاسخ مستقیم پشتیبانی می‌کنند و نمایش آن‌ها مرتب‌تر شده است.",
            "items": [
              {
                "parts": [
                  {
                    "text": "تصویر در کامنت:",
                    "b": true
                  },
                  {
                    "text": " با پیست کردن تصویر در کادر کامنت، آن را به کامنت اضافه کنید. تصاویر داخل کامنت نمایش داده می‌شوند و قابلیت باز شدن به‌صورت تمام‌صفحه دارند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "پاسخ به کامنت:",
                    "b": true
                  },
                  {
                    "text": " با دابل‌کلیک، یا راست‌کلیک و انتخاب ",
                    "b": false
                  },
                  {
                    "text": "Reply",
                    "b": true
                  },
                  {
                    "text": "، به کامنت پاسخ دهید. در موبایل، با نگه داشتن روی کامنت و انتخاب Reply این کار انجام می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "ارجاع به کامنت اصلی:",
                    "b": true
                  },
                  {
                    "text": " ریپلای شامل نقل‌قولی از کامنت اصلی است که با کلیک روی آن، به همان کامنت می‌روید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نمایش تعداد کامنت‌ها و تغییرات:",
                    "b": true
                  },
                  {
                    "text": " تعداد کامنت‌ها و تغییرات با آیکن و عدد نمایش داده می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "بهبود فاصله و محوشدگی لیست:",
                    "b": true
                  },
                  {
                    "text": " فاصلهٔ بالای اولین کامنت کمتر شده است. افکت محوشدگی بالای لیست فقط زمانی دیده می‌شود که کامنت‌های قدیمی‌تر خارج از محدودهٔ دید باشند.",
                    "b": false
                  }
                ]
              }
            ]
          },
          {
            "title": "۷. اعضای تیم و دعوت به پروژه",
            "intro": "دعوت افراد و مرور وضعیت اعضای پروژه ساده‌تر و منظم‌تر شده است.",
            "items": [
              {
                "parts": [
                  {
                    "text": "پیشنهاد افراد برای دعوت:",
                    "b": true
                  },
                  {
                    "text": " هنگام افزودن عضو تیم، افراد پروژه‌های دیگرتان پیشنهاد می‌شوند. با تایپ می‌توانید پیشنهادها را فیلتر کنید و با یک کلیک فرد موردنظر را دعوت کنید.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "تفکیک اعضا و دعوت‌ها:",
                    "b": true
                  },
                  {
                    "text": " در صفحهٔ تیم پروژه، اعضا و بخش دعوت در دو قسمت جدا قرار دارند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نمایش تعداد در تب‌های فیلتر:",
                    "b": true
                  },
                  {
                    "text": " تب‌های ",
                    "b": false
                  },
                  {
                    "text": "All، Team، Invited و Suggested",
                    "b": true
                  },
                  {
                    "text": " هرکدام تعداد موارد خود را نمایش می‌دهند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "بهبود چیدمان باتم‌شیت:",
                    "b": true
                  },
                  {
                    "text": " لیست تا لبهٔ پایین باتم‌شیت ادامه پیدا می‌کند و باتم‌شیت تنظیمات، ارتفاعی ثابت و کوتاه‌تر دارد.",
                    "b": false
                  }
                ]
              }
            ]
          },
          {
            "title": "۸. شخصی‌سازی ظاهر و هویت پروژه‌ها",
            "intro": "امکان شخصی‌سازی رنگ پروژه‌ها بیشتر شده و یک تم تیرهٔ جدید اضافه شده است.",
            "items": [
              {
                "parts": [
                  {
                    "text": "رنگ اکسنت اختصاصی پروژه:",
                    "b": true
                  },
                  {
                    "text": " از مسیر ",
                    "b": false
                  },
                  {
                    "text": "تنظیمات پروژه › Accent",
                    "b": true
                  },
                  {
                    "text": " برای هر پروژه رنگ اکسنت جداگانه انتخاب کنید. این رنگ فقط روی ستون‌های همان پروژه اعمال می‌شود و پس‌زمینه را تغییر نمی‌دهد.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نمایش رنگ پروژه:",
                    "b": true
                  },
                  {
                    "text": " یک نوار ضخیم به رنگ اکسنت بالای هدر پروژه نمایش داده می‌شود و آیکن پروژه در لیست پروژه‌ها نیز همین رنگ را می‌گیرد.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "تم تیرهٔ London:",
                    "b": true
                  },
                  {
                    "text": " تم جدید با سرمه‌ای متروی لندن، متن به رنگ سنگ پورتلند و اکسنت قرمز اتوبوس اضافه شده است. با انتخاب این تم، اکسنت قرمز اتوبوس خودکار تنظیم می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "رنگ اکسنت جدید:",
                    "b": true
                  },
                  {
                    "text": " قرمز اتوبوس به گزینه‌های رنگ اکسنت نیز اضافه شده است.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "عنوان ستون پروژه‌ها:",
                    "b": true
                  },
                  {
                    "text": " عنوان این ستون به ",
                    "b": false
                  },
                  {
                    "text": "TaskCool",
                    "b": true
                  },
                  {
                    "text": " تغییر کرده است.",
                    "b": false
                  }
                ]
              }
            ]
          },
          {
            "title": "۹. وضعیت اتصال و همگام‌سازی",
            "intro": "وضعیت ذخیره‌سازی تغییرات و اتصال به اینترنت اکنون واضح‌تر نمایش داده می‌شود.",
            "items": [
              {
                "parts": [
                  {
                    "text": "نمایش وضعیت اتصال:",
                    "b": true
                  },
                  {
                    "text": " وضعیت اتصال بالای پروفایل در منوی پروژه‌ها نمایش داده می‌شود.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "حالت آنلاین:",
                    "b": true
                  },
                  {
                    "text": " تغییرات مستقیماً در کلاد ذخیره می‌شوند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "حالت آفلاین:",
                    "b": true
                  },
                  {
                    "text": " تغییرات روی همان دستگاه نگه‌داری می‌شوند و پس از بازگشت اینترنت همگام‌سازی می‌شوند.",
                    "b": false
                  }
                ]
              },
              {
                "parts": [
                  {
                    "text": "نشانگر آفلاین:",
                    "b": true
                  },
                  {
                    "text": " در حالت آفلاین، یک نوار قرمز بالای صفحه باقی می‌ماند.",
                    "b": false
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    {
      "version": "9.3",
      "status": "released",
      "date": "2026-10-11",
      "items": [
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "Typing @ in a project’s comments opens the mention list in that box only",
          "fa": "تایپ @ در کامنت‌های یک پروژه، فهرست منشن را فقط در همان کادر باز می‌کند"
        },
        {
          "area": "sharing",
          "phases": [
            "P13"
          ],
          "en": "People you invite before they have an account find the invitation in their Invites after signing up",
          "fa": "کسانی که قبل از ثبت‌نام دعوت شده‌اند، بعد از ثبت‌نام دعوت را در بخش دعوت‌ها می‌بینند"
        }
      ]
    },
    {
      "version": "9.2",
      "status": "released",
      "date": "2026-10-10",
      "items": [
        {
          "area": "comments",
          "phases": [
            "P07"
          ],
          "en": "Persian: your own comments sit on the right and other people’s on the left",
          "fa": "در فارسی، کامنت‌های خودتان سمت راست و کامنت‌های دیگران سمت چپ قرار می‌گیرند"
        },
        {
          "area": "comments",
          "phases": [
            "P07"
          ],
          "en": "Persian: the emoji picker opens right above its button",
          "fa": "در فارسی، پنجره‌ی ایموجی درست بالای دکمه‌ی خودش باز می‌شود"
        },
        {
          "area": "layout",
          "phases": [
            "P08"
          ],
          "en": "A task opened in its own column no longer shows the project’s trashed-items line over its notes",
          "fa": "تسکی که در ستون جداگانه باز شده دیگر خط «نمایش موارد حذف‌شده»ی پروژه را روی یادداشت‌هایش نشان نمی‌دهد"
        }
      ]
    },
    {
      "version": "9.1",
      "status": "released",
      "date": "2026-10-10",
      "items": [
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "The emoji picker in task and project comments opens again; emoji no longer blink in the picker and in comments",
          "fa": "انتخاب ایموجی در کامنت‌های تسک و پروژه دوباره باز می‌شود؛ ایموجی‌ها دیگر در پنجره‌ی انتخاب و در کامنت‌ها چشمک نمی‌زنند"
        },
        {
          "area": "tasks",
          "phases": [
            "P10"
          ],
          "en": "Selecting several tasks (⌘/Ctrl- or Shift-click) shows the “N tasks selected” bar again",
          "fa": "با انتخاب چند تسک (⌘/Ctrl یا Shift و کلیک) نوار «N تسک انتخاب شده» دوباره نمایش داده می‌شود"
        },
        {
          "area": "files",
          "phases": [
            "P12"
          ],
          "en": "Full-screen task images: the side arrows, the image counter and swiping on phones work",
          "fa": "عکس‌های تمام‌صفحه‌ی تسک: فلش‌های کناری، شمارنده‌ی عکس و کشیدن انگشت در موبایل کار می‌کنند"
        }
      ]
    },
    {
      "version": "9.0",
      "status": "released",
      "date": "2026-10-10",
      "highlights": [
        {
          "en": "Comments-first open task: one bottom bar with the comment box always open, and a Show/Hide details switch",
          "fa": "تسک باز با محوریت کامنت: یک نوار پایین با فرم کامنت همیشه باز، و دکمه‌ی نمایش/پنهان کردن جزئیات."
        },
        {
          "en": "Open a task in its own column",
          "fa": "باز کردن تسک در ستون جدا."
        },
        {
          "en": "Updated sort: recently changed or commented tasks first",
          "fa": "سورت Updated: تسک‌هایی که اخیراً تغییر کرده‌اند یا کامنت گرفته‌اند اول می‌آیند."
        },
        {
          "en": "Filter by list in projects and All Tasks, with search in the … filter menu",
          "fa": "فیلتر بر اساس لیست در پروژه‌ها و All Tasks، با جستجو در منوی … فیلتر."
        },
        {
          "en": "One Updates column for notifications, mentions and invites, with tabs",
          "fa": "یک ستون Updates برای اعلان‌ها، منشن‌ها و دعوت‌ها، با تب."
        },
        {
          "en": "Simpler open task: people and tags in one row, attachments in a dropdown",
          "fa": "تسک باز ساده‌تر: افراد و تگ‌ها در یک ردیف، فایل‌ها در یک دراپ‌داون."
        }
      ],
      "items": [
        {
          "area": "files",
          "phases": [
            "P08"
          ],
          "en": "Full-screen task images: move to the next or previous image with ← / →, the side arrows, or a swipe on phones",
          "fa": "عکس‌های تمام‌صفحه‌ی تسک: با ← / →، فلش‌های کناری یا کشیدن انگشت در موبایل به عکس بعدی یا قبلی بروید"
        },
        {
          "area": "files",
          "phases": [
            "P08"
          ],
          "en": "Pasting an image into a task title adds it to the task’s images",
          "fa": "پیست کردن عکس در عنوان تسک، آن را به عکس‌های تسک اضافه می‌کند"
        },
        {
          "area": "tasks",
          "phases": [
            "P08"
          ],
          "en": "When a column is filtered by a person, lists with none of their tasks are hidden",
          "fa": "وقتی ستون روی یک نفر فیلتر شده، لیست‌هایی که تسکی از او ندارند نمایش داده نمی‌شوند"
        },
        {
          "area": "tasks",
          "phases": [
            "P08"
          ],
          "en": "Dropping a task into a column filtered by a tag or a person gives the task that tag or assignee",
          "fa": "وقتی تسکی را در ستونی که روی یک تگ یا یک نفر فیلتر شده رها می‌کنید، همان تگ یا اساینی به تسک اضافه می‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "Deleting or copying a comment moved to a right-click menu (long-press on phones); the × on bubbles is gone",
          "fa": "حذف یا کپی کامنت به منوی راست‌کلیک منتقل شد (در موبایل با نگه‌داشتن)؛ دکمه‌ی × روی حباب‌ها حذف شد"
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "Emoji picker in the comment box, for task and project comments; emoji play as small animations in the picker and in comments, and a comment with only emoji shows them large without a bubble",
          "fa": "انتخاب اموجی در باکس کامنت، برای کامنت‌های تسک و پروژه؛ اموجی‌ها در انتخاب‌گر و داخل کامنت‌ها متحرک نمایش داده می‌شوند و کامنتی که فقط اموجی دارد، بزرگ و بدون حباب نشان داده می‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "Your own comments sit on the right in an accent-tinted bubble, without your avatar or name",
          "fa": "کامنت‌های خودتان سمت راست و در حبابی به رنگ اکسنت می‌آیند، بدون عکس و نام"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "Projects get their own comments, in a collapsible panel above the lists; they support @ mentions and show up in Updates",
          "fa": "پروژه‌ها کامنت مخصوص خودشان را دارند، در یک پنل جمع‌شونده بالای لیست‌ها؛ این کامنت‌ها منشن @ دارند و در Updates می‌آیند",
          "rank": 0
        },
        {
          "area": "tasks",
          "phases": [
            "P08"
          ],
          "en": "Select several tasks with ⌘/Ctrl-click or Shift-click; drag them together to another spot or list, or right-click for bulk actions (done, assign, duplicate, move, trash)",
          "fa": "انتخاب چند تسک با ⌘/Ctrl-کلیک یا Shift-کلیک؛ می‌توان آن‌ها را با هم به جای دیگر یا لیست دیگر کشید، یا با راست‌کلیک عملیات گروهی انجام داد (دان، اساین، کپی، جابه‌جایی، سطل زباله)",
          "rank": 0
        },
        {
          "area": "stats",
          "phases": [
            "P08"
          ],
          "en": "The screen saver no longer appears while you are typing in a text field",
          "fa": "وقتی در یک فیلد متنی در حال تایپ هستید، اسکرین‌سیور ظاهر نمی‌شود"
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "While typing a comment, the comment box stays on its line; the tool icons overlap as a stack of round buttons next to it and spread out on hover; Send is now a round icon button",
          "fa": "هنگام نوشتن کامنت، باکس کامنت در همان خط می‌ماند؛ آیکن‌های ابزار کنارش به‌صورت دکمه‌های گرد روی هم می‌افتند و با بردن نشانگر رویشان باز می‌شوند؛ دکمه‌ی ارسال هم یک دکمه‌ی آیکنی گرد شد"
        },
        {
          "area": "tasks",
          "phases": [
            "P08"
          ],
          "en": "A calmer open task: assignees and tags share one row with a single + picker; deadline and checklist icons sit in the bottom bar until used; attachments collapse into an “N attachments” dropdown",
          "fa": "تسک باز خلوت‌تر: افراد و تگ‌ها در یک ردیف با یک دکمه‌ی + مشترک؛ آیکن ددلاین و چک‌لیست تا وقتی استفاده نشده‌اند در نوار پایین هستند؛ فایل‌ها در یک دراپ‌داون «N attachments» جمع شده‌اند."
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "One bottom bar in the open task: the comment box is always open, aligned with the comment list, with tool icons beside it; while typing, the icons move to a row below; the rest, plus who added the task and when, are under …",
          "fa": "یک نوار پایین در تسک باز: فرم کامنت همیشه باز و هم‌تراز با لیست کامنت‌هاست و آیکن‌های ابزار کنارش هستند؛ موقع تایپ آیکن‌ها به ردیف پایین می‌روند؛ بقیه، به‌همراه سازنده و زمان ایجاد تسک، زیر … هستند."
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "Comments are more compact: author and time sit at the start of the bubble",
          "fa": "کامنت‌ها جمع‌وجورترند: نام نویسنده و زمان اول حباب کامنت آمده‌اند."
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "Show details / Hide details line above the comments, with the comment and change counts; hiding details keeps only the title and the conversation",
          "fa": "خط Show details / Hide details بالای کامنت‌ها، همراه با تعداد کامنت‌ها و تغییرات؛ با پنهان کردن جزئیات فقط عنوان و گفتگو می‌ماند."
        },
        {
          "area": "comments",
          "phases": [
            "P08"
          ],
          "en": "Recorded changes stay hidden until you click the change count; the comment list opens scrolled to the latest comment, and scrolling past its end scrolls the column",
          "fa": "تغییرات ثبت‌شده تا وقتی روی تعدادشان کلیک نکنید پنهان‌اند؛ لیست کامنت‌ها روی آخرین کامنت باز می‌شود و اسکرول بعد از انتهای آن، ستون را اسکرول می‌کند."
        },
        {
          "area": "tasks",
          "phases": [
            "P08"
          ],
          "en": "Open a task in its own column (right-click or …): compact header with the task title and checkbox, details shown flat, and the comment bar pinned to the bottom",
          "fa": "باز کردن تسک در ستون جدا (راست‌کلیک یا …): هدر فشرده با عنوان و چک‌باکس تسک، جزئیات بدون کادر، و نوار کامنت چسبیده به پایین صفحه."
        },
        {
          "area": "alltasks",
          "phases": [
            "P08"
          ],
          "en": "New Updated sort next to search, in projects and All Tasks: recently changed or commented tasks first, each showing its latest change",
          "fa": "سورت جدید Updated کنار جستجو، در پروژه‌ها و All Tasks: تسک‌هایی که اخیراً تغییر کرده‌اند یا کامنت گرفته‌اند اول می‌آیند و آخرین تغییرشان زیر عنوان نوشته می‌شود."
        },
        {
          "area": "alltasks",
          "phases": [
            "P08"
          ],
          "en": "Lists join tags and people in the filter row of projects and All Tasks (same-named lists merge in All Tasks)",
          "fa": "لیست‌ها کنار تگ‌ها و افراد در ردیف فیلتر پروژه‌ها و All Tasks آمده‌اند (در All Tasks لیست‌های هم‌نام یکی می‌شوند)."
        },
        {
          "area": "alltasks",
          "phases": [
            "P08"
          ],
          "en": "The … filter menu has a search box, icons for lists and tags, the selected item shown as a chip, and Edit filter order at the end of the list",
          "fa": "منوی … فیلتر جستجو دارد، لیست‌ها و تگ‌ها آیکن دارند، مورد انتخاب‌شده به‌شکل چیپ نشان داده می‌شود و Edit filter order آخر لیست است."
        },
        {
          "area": "alltasks",
          "phases": [
            "P08"
          ],
          "en": "All Tasks & Search opens with search shown and sorted By list",
          "fa": "All Tasks & Search با نوار جستجوی باز و مرتب‌سازی By list باز می‌شود."
        },
        {
          "area": "menu",
          "phases": [
            "P08"
          ],
          "en": "Notifications, Mentions and Invites open in one Updates column with tag-style tabs and counters; the title and description follow the selected tab",
          "fa": "اعلان‌ها، منشن‌ها و دعوت‌ها در یک ستون Updates با تب‌هایی شبیه تگ و شمارنده باز می‌شوند؛ عنوان و توضیح بر اساس تب انتخاب‌شده عوض می‌شود."
        },
        {
          "area": "layout",
          "phases": [
            "P08"
          ],
          "en": "Columns opened from the menu get the same sticky header as projects; the header no longer flickers between compact and full near the top",
          "fa": "ستون‌هایی که از منو باز می‌شوند مثل پروژه‌ها هدر استیکی دارند؛ هدر نزدیک بالای صفحه دیگر بین حالت فشرده و کامل چشمک نمی‌زند."
        },
        {
          "area": "tasks",
          "phases": [
            "P08"
          ],
          "en": "Menus and pickers in an open task (…, attachments, + person or tag) open only for that task",
          "fa": "منوها و انتخاب‌گرهای تسک باز (…، فایل‌ها، + person or tag) فقط برای همان تسک باز می‌شوند."
        }
      ]
    },
    {
      "version": "8.8",
      "status": "released",
      "date": "2026-10-09",
      "items": [
        {
          "area": "app",
          "phases": [
            "P18"
          ],
          "en": "The app updates itself to the newest version: right away when it is in the background, otherwise after a short pause when you are not typing — unsaved work is never lost",
          "fa": "اپ خودش به آخرین نسخه به‌روز می‌شود: اگر در پس‌زمینه باشد بلافاصله، وگرنه بعد از چند ثانیه مکث وقتی در حال تایپ نیستید — کار ذخیره‌نشده از بین نمی‌رود"
        }
      ]
    },
    {
      "version": "8.7",
      "status": "released",
      "date": "2026-10-09",
      "items": [
        {
          "area": "assign",
          "phases": [
            "P09"
          ],
          "en": "The person filter shows only people who have an open task assigned to them",
          "fa": "فیلتر افراد فقط کسانی را نشان می‌دهد که تسک باز به آن‌ها اساین شده است"
        },
        {
          "area": "app",
          "phases": [
            "P04"
          ],
          "en": "Installed app: after the computer sleeps, changes save again without restarting the app (the device storage reconnects by itself)",
          "fa": "اپ نصب‌شده: بعد از خواب رفتن کامپیوتر، تغییرات بدون بستن و باز کردن اپ دوباره ذخیره می‌شوند (حافظه‌ی دستگاه خودش دوباره وصل می‌شود)"
        }
      ]
    },
    {
      "version": "8.6",
      "status": "released",
      "date": "2026-10-09",
      "items": [
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "Forgot your password? An admin can send you a reset link; the link opens a page to choose a new password",
          "fa": "رمز را فراموش کرده‌اید؟ ادمین می‌تواند لینک تغییر رمز برایتان بفرستد؛ لینک صفحه‌ی انتخاب رمز جدید را باز می‌کند"
        },
        {
          "area": "trash",
          "phases": [
            "P10"
          ],
          "en": "Deleted files stay in Trash for the restore period like tasks and projects",
          "fa": "فایل‌های حذف‌شده هم مثل تسک‌ها و پروژه‌ها تا پایان مهلت بازیابی در سطل زباله می‌مانند"
        }
      ]
    },
    {
      "version": "8.3",
      "status": "released",
      "date": "2026-10-08",
      "items": [
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "In the installed app, clicking your photo in Profile opens the file browser again",
          "fa": "در اپ نصب‌شده، کلیک روی عکس پروفایل دوباره پنجره‌ی انتخاب فایل را باز می‌کند"
        }
      ]
    },
    {
      "version": "8.2",
      "status": "released",
      "date": "2026-10-08",
      "items": [
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "Profile photo: photos the browser can’t open (such as HEIC) now get a clear message, and the picker offers supported formats",
          "fa": "عکس پروفایل: برای قالب‌هایی که مرورگر باز نمی‌کند (مثل HEIC) پیام روشن نمایش داده می‌شود و انتخاب‌گر فقط قالب‌های پشتیبانی‌شده را پیشنهاد می‌دهد"
        }
      ]
    },
    {
      "version": "8.1",
      "status": "released",
      "date": "2026-10-08",
      "items": [
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "In Persian, the right-click task menu opens at the pointer again",
          "fa": "در فارسی، منوی راست‌کلیک تسک دوباره درست کنار نشانگر باز می‌شود"
        }
      ]
    },
    {
      "version": "8.0",
      "status": "released",
      "date": "2026-10-08",
      "highlights": [
        {
          "en": "Assign tasks to people and filter by person",
          "fa": "اساین کردن تسک‌ها به افراد و فیلتر بر اساس شخص"
        },
        {
          "en": "Search and sort inside every project, and in All Tasks & Search",
          "fa": "جستجو و مرتب‌سازی داخل هر پروژه و در All Tasks & Search"
        },
        {
          "en": "Rename tags; renaming to an existing tag merges them",
          "fa": "تغییر نام تگ‌ها؛ تغییر نام به یک تگ موجود آن‌ها را ادغام می‌کند"
        },
        {
          "en": "Simpler project settings: a short menu with its own pages, quick stats and a link to full stats",
          "fa": "تنظیمات ساده‌تر پروژه: یک منوی کوتاه با صفحه‌های جدا، آمار سریع و لینک به آمار کامل"
        },
        {
          "en": "Tags sit right after the task title, even when it wraps",
          "fa": "تگ‌ها درست بعد از عنوان تسک می‌آیند، حتی وقتی عنوان چندخطی است"
        },
        {
          "en": "Higher text contrast in every theme, and a new dark Wine theme",
          "fa": "کنتراست بیشتر متن در همه‌ی تم‌ها و تم تیره‌ی جدید Wine"
        },
        {
          "en": "Profile reorganised, with chip-style Appearance, Density and Language",
          "fa": "پروفایل مرتب‌تر، با چیپ‌های Appearance، Density و Language"
        },
        {
          "en": "Done and trashed tasks in their own lists at the bottom of the project",
          "fa": "نمایش تسک‌های انجام‌شده و حذف‌شده در لیست‌های جدا پایین پروژه، به ترتیب زمان"
        },
        {
          "en": "Right-click menu on tasks",
          "fa": "امکان راست‌کلیک روی تسک‌ها"
        }
      ],
      "items": [
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "Assign tasks to project members; assignees show as small avatars before the task title",
          "fa": "اساین کردن تسک به اعضای پروژه؛ آواتار افراد اساین‌شده قبل از عنوان تسک نمایش داده می‌شود",
          "rank": 0
        },
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "Filter a shared project by person (or Unassigned) from the row of name chips under the tags",
          "fa": "فیلتر پروژه‌ی اشتراکی بر اساس شخص (یا بدون اساین) از ردیف چیپ‌های اسم زیر تگ‌ها"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "Tags inside an open task use the same outlined style as tags on the list rows",
          "fa": "تگ‌های داخل تسک باز همان ظاهر خطی تگ‌های ردیف لیست را دارند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Clicking the selected tag filter again goes back to All",
          "fa": "کلیک دوباره روی تگ انتخاب‌شده در فیلتر، به All برمی‌گردد"
        },
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "The person filter row matches the tag row: same chips, starting with All and ending with No one (like No tag)",
          "fa": "ردیف فیلتر افراد مثل ردیف تگ‌هاست: همان چیپ‌ها، با All در ابتدا و No one (مثل No tag) در انتها"
        },
        {
          "area": "activity",
          "phases": [
            "P10"
          ],
          "en": "Everyday task edits (title, notes, checklist, deadline, tags, assignees) no longer show the Undo bar; changes stay in the task timeline",
          "fa": "ویرایش‌های معمول تسک (عنوان، یادداشت، چک‌لیست، ددلاین، تگ‌ها، افراد) دیگر نوار Undo نشان نمی‌دهند؛ تغییرات در تایم‌لاین تسک می‌مانند"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "Project settings is a short menu (Icon, Project team, Read-only links, Tags, Lists); each item opens its own page",
          "fa": "تنظیمات پروژه به یک منوی کوتاه تبدیل شد (آیکن، تیم پروژه، لینک‌های فقط‌خواندنی، تگ‌ها، لیست‌ها) که هر آیتم صفحه‌ی خودش را باز می‌کند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Rename a tag from Project settings › Tags; renaming to an existing tag merges them",
          "fa": "تغییر نام تگ از تنظیمات پروژه › تگ‌ها؛ تغییر نام به یک تگ موجود، آن دو را ادغام می‌کند"
        },
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "“No one” appears in the Project team list and can be dragged to set its place in the person filter",
          "fa": "«No one» در لیست تیم پروژه آمده و با کشیدن، جایش در فیلتر افراد تغییر می‌کند"
        },
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "Give people (and No one) a nickname in Project team; it is used in the person filter and assignee chips of that project",
          "fa": "برای افراد (و No one) در تیم پروژه نیک‌نیم بگذارید؛ در فیلتر افراد و چیپ‌های اساین همان پروژه استفاده می‌شود"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "Higher text contrast in every theme; secondary and muted text is easier to read",
          "fa": "کنتراست متن در همه‌ی تم‌ها بیشتر شد؛ متن‌های ثانویه و کم‌رنگ خواناترند"
        },
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "All Tasks & Search has the person filter too, and shows assignee photos before each task title",
          "fa": "All Tasks & Search هم فیلتر افراد را دارد و عکس افراد اساین‌شده را قبل از عنوان هر تسک نشان می‌دهد"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "New Wine theme: a dark take on Rose",
          "fa": "تم جدید Wine: نسخه‌ی تیره‌ی Rose"
        },
        {
          "area": "trash",
          "phases": [
            "P10"
          ],
          "en": "Drag a project from the Projects column onto Trash to delete it (owner only; Undo for 5 seconds)",
          "fa": "یک پروژه را از ستون پروژه‌ها روی Trash بکشید تا حذف شود (فقط مالک؛ Undo تا ۵ ثانیه)"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Redesigned added-date button in an open task: a pill with the creator’s photo instead of their name; its popup is redesigned too, showing the creator’s photo, who added the task and when, in one block",
          "fa": "ظاهر دکمه‌ی تاریخ ایجاد در تسک باز کاملاً عوض شد: یک چیپ با عکس سازنده به‌جای نامش؛ پنجره‌ی آن هم بازطراحی شد و در یک بخش عکس سازنده، اینکه چه کسی و کی تسک را اضافه کرده نشان می‌دهد"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Clicking the added date no longer scrolls the column",
          "fa": "کلیک روی تاریخ ایجاد دیگر ستون را اسکرول نمی‌کند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "In an open task, tags and the + tag field sit right under the title",
          "fa": "در تسک باز، تگ‌ها و فیلد + tag درست زیر عنوان آمده‌اند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Show done (Project settings) shows done tasks in place inside their lists; Show logged items still lists them at the bottom by completion time",
          "fa": "Show done در تنظیمات پروژه، تسک‌های انجام‌شده را سر جای خودشان داخل لیست‌ها نشان می‌دهد؛ Show logged items همچنان آن‌ها را پایین پروژه به ترتیب زمان انجام لیست می‌کند"
        },
        {
          "area": "trash",
          "phases": [
            "P10"
          ],
          "en": "Below Show logged items, Show trashed items lists the project’s deleted tasks, newest first, with Restore",
          "fa": "زیر Show logged items، دکمه‌ی Show trashed items تسک‌های حذف‌شده‌ی پروژه را به ترتیب زمان حذف (جدیدترین اول) و با امکان بازگردانی نشان می‌دهد"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Show logged items lists done tasks at the bottom of the project, newest first, with the done time in the accent colour",
          "fa": "Show logged items تسک‌های انجام‌شده را پایین پروژه، به ترتیب زمان انجام (جدیدترین اول) و با زمان انجام به رنگ اکسنت نشان می‌دهد"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "The browser right-click menu is turned off; right-clicking a task opens a task menu (Open, Mark as done, Assign to me, Duplicate, Copy title, Move to another list, Move to Trash)",
          "fa": "منوی راست‌کلیک مرورگر غیرفعال شد؛ راست‌کلیک روی تسک منوی مخصوص تسک را باز می‌کند (باز کردن، انجام شد، اساین به خودم، تکثیر، کپی عنوان، انتقال به لیست دیگر، انتقال به سطل زباله)"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "Appearance in Profile is a single row of theme chips like the filter row; the rest are under …; Density and Language use the same chips",
          "fa": "بخش ظاهر در پروفایل یک ردیف چیپ تم شبیه ردیف فیلترهاست و باقی تم‌ها زیر … هستند؛ تراکم و زبان هم همین چیپ‌ها را دارند"
        },
        {
          "area": "account",
          "phases": [
            "P15"
          ],
          "en": "Profile sections reordered: look (Appearance, Accent, Density, Screen saver) first, then Language & Calendar, Notifications, Account, App, Support and Switch account",
          "fa": "ترتیب بخش‌های پروفایل منطقی‌تر شد: اول ظاهر (تم، رنگ اکسنت، تراکم، اسکرین‌سیور)، بعد زبان و تقویم، اعلان‌ها، حساب کاربری، اپ، پشتیبانی و تعویض حساب"
        },
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "People and tags share one filter row in projects and All Tasks & Search; set their mixed order in Project settings › Filter order (Tags and Team no longer have their own ordering)",
          "fa": "افراد و تگ‌ها در پروژه‌ها و All Tasks & Search در یک ردیف فیلتر کنار هم آمده‌اند؛ ترتیب مختلط آن‌ها از تنظیمات پروژه › ترتیب فیلترها تنظیم می‌شود (تگ‌ها و تیم دیگر ترتیب جداگانه ندارند)"
        },
        {
          "area": "alltasks",
          "phases": [
            "P09"
          ],
          "en": "All Tasks & Search: the search chip comes first in the filter row and opens the search & sort bar below it",
          "fa": "All Tasks & Search: چیپ جستجو اولین چیپ ردیف فیلتر است و نوار جستجو و مرتب‌سازی را زیرش باز می‌کند"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "Projects get the same search chip and search & sort bar: search titles, notes, checklist and tags; sort each list by order, newest or oldest",
          "fa": "پروژه‌ها هم همان چیپ جستجو و نوار جستجو و مرتب‌سازی را دارند: جستجو در عنوان، یادداشت، چک‌لیست و تگ‌ها؛ مرتب‌سازی هر لیست بر اساس ترتیب، جدیدترین یا قدیمی‌ترین"
        },
        {
          "area": "alltasks",
          "phases": [
            "P09"
          ],
          "en": "All Tasks & Search: search and sort share one bar below the filters; sort options are icons (list, newest, oldest) and the selected one shows its name",
          "fa": "All Tasks & Search: جستجو و مرتب‌سازی در یک نوار زیر فیلترها آمده‌اند؛ گزینه‌های مرتب‌سازی آیکن‌اند (لیست، جدیدترین، قدیمی‌ترین) و گزینه‌ی انتخاب‌شده نامش را هم نشان می‌دهد"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "Project settings drops the Settings / Stats tabs for two stat boxes (open tasks, done in 7 days) and a link to the Stats page",
          "fa": "تب‌های تنظیمات و آمار حذف شدند؛ به‌جایشان دو باکس آمار (تسک‌های باز، انجام‌شده در ۷ روز) و لینک صفحه‌ی آمار آمده است"
        },
        {
          "area": "assign",
          "phases": [
            "P09",
            "P13"
          ],
          "en": "“Shared with” is now “Project team”; drag people to reorder them, and the person filter follows that order",
          "fa": "بخش Shared with به «تیم پروژه» تغییر کرد؛ افراد با کشیدن جابه‌جا می‌شوند و فیلتر افراد بالای لیست همان ترتیب را دارد"
        }
      ]
    },
    {
      "version": "7.6",
      "status": "released",
      "date": "2026-10-07",
      "items": [
        {
          "area": "layout",
          "phases": [
            "P07"
          ],
          "en": "When everything is synced, the footer shows just a green dot, so “What’s new” fits again",
          "fa": "وقتی همه‌چیز همگام است، پایین ستون فقط یک نقطه‌ی سبز نشان می‌دهد تا «تازه‌ها» کامل دیده شود"
        }
      ]
    },
    {
      "version": "7.5",
      "status": "released",
      "date": "2026-10-07",
      "items": [
        {
          "area": "layout",
          "phases": [
            "P07"
          ],
          "en": "The sync status under the Projects list is no longer cut off",
          "fa": "وضعیت همگام‌سازی زیر لیست پروژه‌ها دیگر بریده نمی‌شود"
        }
      ]
    },
    {
      "version": "7.4",
      "status": "released",
      "date": "2026-10-07",
      "items": [
        {
          "area": "comments",
          "phases": [
            "P14"
          ],
          "en": "Send a test notification from Profile to check push on your device",
          "fa": "از پروفایل یک اعلان آزمایشی بفرستید تا پوش را روی دستگاهتان بررسی کنید"
        },
        {
          "area": "mobile",
          "phases": [
            "P18"
          ],
          "en": "Profile → App now offers Install when possible and says Installed when the app is installed",
          "fa": "بخش اپ در پروفایل حالا در صورت امکان دکمه‌ی نصب دارد و اگر اپ نصب باشد «نصب شده» نشان می‌دهد"
        }
      ]
    },
    {
      "version": "7.3",
      "status": "released",
      "date": "2026-10-07",
      "highlights": [
        {
          "en": "Push notifications",
          "fa": "اعلان پوش"
        }
      ],
      "items": [
        {
          "area": "comments",
          "rank": 0,
          "phases": [
            "P14"
          ],
          "en": "Push notifications: turn them on in Profile → Notifications to get mentions, comments, invites, shared projects and deadline reminders on this device, even when the app is in the background",
          "fa": "اعلان پوش: از پروفایل ← اعلان‌ها روشنش کنید تا منشن‌ها، کامنت‌ها، دعوت‌ها، پروژه‌های اشتراکی و یادآوری ددلاین روی همین دستگاه برسد، حتی وقتی اپ در پس‌زمینه است"
        },
        {
          "area": "comments",
          "phases": [
            "P14",
            "P08"
          ],
          "en": "Tapping a notification or an e-mail link opens the task (or the Invites list)",
          "fa": "با زدن روی اعلان یا لینک ایمیل، همان تسک (یا لیست دعوت‌ها) باز می‌شود"
        },
        {
          "area": "mobile",
          "phases": [
            "P14"
          ],
          "en": "On iPhone and iPad, add TaskCool to the Home Screen first to receive notifications",
          "fa": "در آیفون و آیپد برای دریافت اعلان، ابتدا TaskCool را به صفحه‌ی اصلی اضافه کنید"
        }
      ]
    },
    {
      "version": "7.2",
      "status": "released",
      "date": "2026-10-07",
      "items": [
        {
          "area": "comments",
          "phases": [
            "P14"
          ],
          "en": "E-mail subjects in Persian now display correctly",
          "fa": "عنوان ایمیل‌های فارسی حالا درست نمایش داده می‌شود"
        }
      ]
    },
    {
      "version": "7.1",
      "status": "released",
      "date": "2026-10-06",
      "items": [
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Task rows no longer show the avatar of who added the task; the open task still shows their name next to the date",
          "fa": "ردیف تسک‌ها دیگر آواتار سازنده را نشان نمی‌دهند؛ تسک باز همچنان نام او را کنار تاریخ نشان می‌دهد"
        }
      ]
    },
    {
      "version": "7.0",
      "status": "released",
      "date": "2026-10-06",
      "highlights": [
        {
          "en": "Comments on tasks, with @ mentions",
          "fa": "امکان کامنت گذاشتن روی تسک‌ها با امکان منشن کردن افراد"
        },
        {
          "en": "Screen saver with 30-day stats",
          "fa": "اسکرین‌سیور با آمار ۳۰ روزه"
        },
        {
          "en": "Icons for projects",
          "fa": "آیکن برای پروژه‌ها"
        },
        {
          "en": "Updates: notifications, mentions and invites in one place",
          "fa": "Updates: اعلان‌ها، منشن‌ها و دعوت‌ها در یک جا"
        },
        {
          "en": "Images in task notes",
          "fa": "تصویر در یادداشت تسک"
        },
        {
          "en": "Search moved into All Tasks",
          "fa": "انتقال جستجو به All Tasks"
        },
        {
          "en": "Profile photo upload",
          "fa": "آپلود عکس پروفایل"
        },
        {
          "en": "Three new themes",
          "fa": "سه تم جدید"
        },
        {
          "en": "The app is now TaskCool",
          "fa": "نام جدید اپ: TaskCool"
        }
      ],
      "items": [
        {
          "area": "app",
          "phases": [
            "P15"
          ],
          "en": "Grouped changelog starts each version with a Highlights list",
          "fa": "چنج‌لاگ گروه‌بندی‌شده هر نسخه را با فهرست خلاصه‌ی موارد مهم شروع می‌کند"
        },
        {
          "area": "app",
          "phases": [
            "P15"
          ],
          "en": "Changelog can be grouped by area and read in Persian",
          "fa": "چنج‌لاگ را می‌توان بر اساس بخش گروه‌بندی کرد و به فارسی خواند"
        },
        {
          "area": "alltasks",
          "phases": [
            "P09"
          ],
          "en": "Search moved from the Projects menu into All Tasks; it filters the list by title, notes, project, list or tag",
          "fa": "جستجو از منوی پروژه‌ها به All Tasks منتقل شد؛ لیست را بر اساس عنوان، یادداشت، پروژه، لیست یا تگ فیلتر می‌کند"
        },
        {
          "area": "app",
          "phases": [
            "P07"
          ],
          "en": "The app is now called TaskCool",
          "fa": "نام اپ به TaskCool تغییر کرد"
        },
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "Upload your own profile photo from Profile (cropped to a square)",
          "fa": "آپلود عکس پروفایل از صفحه‌ی پروفایل (به‌صورت مربع برش می‌خورد)"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "New projects: clicking the name selects it for typing, and after you name it the icon picker opens",
          "fa": "پروژه‌ی جدید: با کلیک روی اسم، کل متن انتخاب می‌شود و بعد از نام‌گذاری، انتخاب آیکن باز می‌شود"
        },
        {
          "area": "activity",
          "phases": [
            "P10"
          ],
          "en": "No undo bar for actions you can simply reverse: ticking tasks or checklist items, moving tasks, restoring from Trash",
          "fa": "برای کارهای برگشت‌پذیر مثل تیک زدن تسک یا آیتم چک‌لیست، جابه‌جایی تسک و بازگردانی از سطل زباله دیگر نوار Undo نمی‌آید"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "Three new appearances: Mocha, Forest (dark) and Rose (light)",
          "fa": "سه تم جدید: Mocha، Forest (تیره) و Rose (روشن)"
        },
        {
          "area": "stats",
          "phases": [
            "P07"
          ],
          "en": "With the screen saver on, the empty-screen chart is hidden",
          "fa": "وقتی اسکرین‌سیور روشن است، نمودار صفحه‌ی خالی نمایش داده نمی‌شود"
        },
        {
          "area": "stats",
          "phases": [
            "P07"
          ],
          "en": "Screen saver stays while the pointer rests on the chart, showing it at full strength with axis lines; a click elsewhere or moving away hides it",
          "fa": "اسکرین‌سیور تا وقتی نشانگر روی نمودار است می‌ماند و با خطوط محور پررنگ می‌شود؛ با کلیک در جای دیگر یا دور شدن پنهان می‌شود"
        },
        {
          "area": "stats",
          "rank": 0,
          "phases": [
            "P07"
          ],
          "en": "Screen saver: on desktop, the 30-day stats fade in over the screen after 10 seconds idle and fade out when you move; can be turned off in Profile",
          "fa": "اسکرین‌سیور: در دسکتاپ بعد از ۱۰ ثانیه بی‌حرکتی، آمار ۳۰ روزه روی صفحه ظاهر می‌شود و با حرکت موس محو می‌شود؛ از پروفایل قابل خاموش کردن است"
        },
        {
          "area": "projects",
          "rank": 0,
          "phases": [
            "P08"
          ],
          "en": "Pick a project icon from a built-in set of 103 single-colour icons in Project settings, with search; it shows next to the project and in the collapsed menu",
          "fa": "انتخاب آیکن پروژه از مجموعه‌ی ۱۰۳ آیکن تک‌رنگ در تنظیمات پروژه، با جستجو؛ کنار پروژه و در منوی فشرده نمایش داده می‌شود"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "Icon picker opens as its own full-height view with category chips and a fixed search bar; the keyboard no longer opens on its own",
          "fa": "انتخاب‌گر آیکن به‌صورت نمای تمام‌قد با دسته‌بندی‌ها و نوار جستجوی ثابت باز می‌شود؛ کیبورد خودبه‌خود باز نمی‌شود"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "After choosing, Project settings shows only the selected icon with a Change button",
          "fa": "بعد از انتخاب، تنظیمات پروژه فقط آیکن انتخاب‌شده را با دکمه‌ی Change نشان می‌دهد"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "Project icon shows in the column header before the project name, aligned with it",
          "fa": "آیکن پروژه در هدر ستون، قبل از نام پروژه و هم‌تراز با آن نمایش داده می‌شود"
        },
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "Empty projects can be deleted without typing DELETE; projects with tasks still ask for it",
          "fa": "پروژه‌های خالی بدون تایپ DELETE حذف می‌شوند؛ پروژه‌های دارای تسک همچنان آن را می‌خواهند"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "Appearance shows all themes in a two-row grid",
          "fa": "بخش Appearance همه‌ی تم‌ها را در یک جدول دوردیفه نشان می‌دهد"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Task titles show in full on multiple lines, both in the list and when the task is open",
          "fa": "عنوان تسک‌ها هم در لیست و هم در حالت باز، کامل و چندخطی نمایش داده می‌شود"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Double-click to open a task works reliably, including on touch screens",
          "fa": "باز کردن تسک با دابل‌کلیک، از جمله روی صفحه‌های لمسی، درست کار می‌کند"
        },
        {
          "area": "sharing",
          "phases": [
            "P09"
          ],
          "en": "In shared projects, the open task shows who added it next to the date",
          "fa": "در پروژه‌های اشتراکی، تسک باز نام کسی را که آن را اضافه کرده کنار تاریخ نشان می‌دهد"
        },
        {
          "area": "comments",
          "rank": 0,
          "phases": [
            "P13"
          ],
          "en": "Comments on tasks, with @ mentions; a comment count shows on the task row",
          "fa": "کامنت روی تسک‌ها با امکان منشن @؛ تعداد کامنت‌ها روی ردیف تسک دیده می‌شود"
        },
        {
          "area": "menu",
          "phases": [
            "P13"
          ],
          "en": "Notifications, Mentions and Invites merged into one Updates item with three separate counters (always shown, dimmed at zero); click Updates for a menu listing all three with their counts, or click a counter to open that list directly",
          "fa": "Notifications، Mentions و Invites در یک آیتم Updates با سه شمارنده‌ی جدا ادغام شدند (همیشه دیده می‌شوند و در صفر کم‌رنگ‌اند)؛ کلیک روی Updates منویی با هر سه و تعدادشان باز می‌کند و کلیک روی هر شمارنده مستقیم همان لیست را باز می‌کند"
        },
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "Notifications in the Projects menu: new comments on your tasks or on tasks you commented on",
          "fa": "Notifications در منوی پروژه‌ها: کامنت‌های جدید روی تسک‌های شما یا تسک‌هایی که رویشان کامنت گذاشته‌اید"
        },
        {
          "area": "comments",
          "phases": [
            "P13"
          ],
          "en": "Comments and the change history are one timeline: comments show in bubbles with the author’s photo, changes as small grey lines with before → after",
          "fa": "کامنت‌ها و تاریخچه‌ی تغییرات یک تایم‌لاین شدند: کامنت‌ها در حباب با عکس نویسنده و تغییرات به‌صورت خطوط خاکستری کوچک با قبل ← بعد"
        },
        {
          "area": "files",
          "phases": [
            "P12"
          ],
          "en": "Images in task notes: paste, drop or add them with the image button; click to view large",
          "fa": "تصویر در یادداشت تسک: با پیست، کشیدن یا دکمه‌ی تصویر اضافه کنید؛ برای دیدن در اندازه‌ی بزرگ کلیک کنید"
        },
        {
          "area": "app",
          "phases": [
            "P15"
          ],
          "en": "Version numbers now follow the design: this release is 7.0",
          "fa": "شماره‌ی نسخه‌ها حالا مثل طرح است: این نسخه ۷.۰ است"
        }
      ]
    },
    {
      "version": "0.2.10",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "app",
          "phases": [
            "P14"
          ],
          "en": "Live updates are faster: changes reach your other devices and teammates almost instantly",
          "fa": "به‌روزرسانی زنده سریع‌تر شد: تغییرات تقریباً بلافاصله به دستگاه‌های دیگر و هم‌تیمی‌ها می‌رسد"
        }
      ]
    },
    {
      "version": "0.2.9",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "app",
          "phases": [
            "P14"
          ],
          "en": "Live updates: changes from your other devices and your teammates, and new invites, appear by themselves — no refresh needed",
          "fa": "به‌روزرسانی زنده: تغییرات دستگاه‌های دیگرتان و هم‌تیمی‌ها و دعوت‌های تازه خودشان ظاهر می‌شوند؛ دیگر نیازی به refresh نیست"
        }
      ]
    },
    {
      "version": "0.2.8",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "mobile",
          "phases": [
            "P18"
          ],
          "en": "New versions now arrive when you open the app, and open tabs check for updates by themselves",
          "fa": "نسخه‌های جدید حالا با باز کردن برنامه دریافت می‌شوند و تب‌های باز هم خودشان به‌روزرسانی را بررسی می‌کنند"
        }
      ]
    },
    {
      "version": "0.2.7",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "projects",
          "phases": [
            "P08",
            "P13"
          ],
          "en": "Your own projects and the projects shared with you are now listed together",
          "fa": "پروژه‌های خودتان و پروژه‌هایی که با شما به اشتراک گذاشته شده‌اند حالا با هم در یک فهرست نشان داده می‌شوند"
        },
        {
          "area": "sharing",
          "phases": [
            "P13"
          ],
          "en": "Inviting someone right after creating a project no longer fails",
          "fa": "دعوت کردن بلافاصله پس از ساختن پروژه دیگر خطا نمی‌دهد"
        }
      ]
    },
    {
      "version": "0.2.6",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "app",
          "phases": [
            "P15"
          ],
          "en": "This “What’s new” list now shows every release",
          "fa": "فهرست «تازه‌ها» حالا همهٔ نسخه‌ها را نشان می‌دهد"
        }
      ]
    },
    {
      "version": "0.2.5",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "menu",
          "phases": [
            "P08",
            "P13"
          ],
          "en": "Workspace switcher in the Projects menu: after accepting a share you can go back to your own workspace and forth to shared ones; each shared workspace shows its owner’s name",
          "fa": "انتخاب فضای کاری در منوی پروژه‌ها: پس از پذیرفتن یک اشتراک، می‌توانید به فضای کاری خودتان برگردید و بین فضاهای مشترک جابه‌جا شوید؛ هر فضای مشترک با نام صاحبش نشان داده می‌شود"
        }
      ]
    },
    {
      "version": "0.2.4",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "app",
          "phases": [
            "P04"
          ],
          "en": "If the server can’t be reached when the app opens, the offline screen now retries by itself and has a “Try again” button",
          "fa": "اگر هنگام باز شدن برنامه سرور در دسترس نباشد، صفحهٔ آفلاین حالا خودش دوباره تلاش می‌کند و دکمهٔ «دوباره تلاش کنید» دارد"
        }
      ]
    },
    {
      "version": "0.2.3",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "comments",
          "phases": [
            "P14"
          ],
          "en": "Invitation and notification e-mails are delivered again",
          "fa": "ایمیل‌های دعوت و اعلان دوباره ارسال می‌شوند"
        }
      ]
    },
    {
      "version": "0.2.2",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "Your profile (name, username) refreshes as soon as the connection returns, without reloading",
          "fa": "پروفایل شما (نام و نام کاربری) به‌محض برقراری اتصال، بدون نیاز به بارگذاری دوبارهٔ صفحه به‌روز می‌شود"
        }
      ]
    },
    {
      "version": "0.2.1",
      "status": "released",
      "date": "2026-10-05",
      "items": [
        {
          "area": "projects",
          "phases": [
            "P08"
          ],
          "en": "“+ New list” selects the new list’s name so you can type its name right away",
          "fa": "«+ لیست جدید» اسم لیست تازه را انتخاب می‌کند تا بلافاصله نامش را بنویسید"
        },
        {
          "area": "app",
          "phases": [
            "P06"
          ],
          "en": "The “Changes that need review” sheet was removed",
          "fa": "برگهٔ «تغییراتی که نیاز به بررسی دارند» حذف شد"
        }
      ]
    },
    {
      "version": "0.2.0",
      "status": "released",
      "date": "2026-10-04",
      "items": [
        {
          "area": "alltasks",
          "phases": [
            "P09"
          ],
          "en": "Search is the first item of the Projects menu: find projects and tasks by title, notes and checklist text, even offline",
          "fa": "جست‌وجو، نخستین گزینهٔ منوی پروژه‌ها: پروژه‌ها و تسک‌ها را با عنوان، یادداشت و متن چک‌لیست پیدا کنید، حتی آفلاین",
          "img": "images/changelog/0.2.0-search.png"
        },
        {
          "area": "stats",
          "phases": [
            "P15"
          ],
          "en": "With only the Projects column open, the background shows tasks added and done per day over the last 30 days; hover the chart for each day’s counts",
          "fa": "وقتی فقط ستون پروژه‌ها باز است، پس‌زمینه تسک‌های اضافه‌شده و انجام‌شدهٔ هر روز در ۳۰ روز گذشته را نشان می‌دهد؛ برای دیدن آمار هر روز، نشانگر را روی نمودار ببرید"
        },
        {
          "area": "menu",
          "phases": [
            "P08"
          ],
          "en": "Reorder projects in the Projects list by dragging (or Alt+↑/↓); the order is yours and follows you to your other devices",
          "fa": "ترتیب پروژه‌ها را در فهرست پروژه‌ها با کشیدن (یا Alt+↑/↓) تغییر دهید؛ این ترتیب فقط برای شماست و روی دستگاه‌های دیگرتان هم می‌آید"
        },
        {
          "area": "alltasks",
          "phases": [
            "P09"
          ],
          "en": "All Tasks can be shown By list: open tasks of all your projects grouped under their list names, with same-named lists shown together",
          "fa": "همه تسک‌ها را می‌توان «بر اساس لیست» دید: تسک‌های باز همهٔ پروژه‌ها زیر نام لیستشان گروه‌بندی می‌شوند و لیست‌های هم‌نام کنار هم می‌آیند"
        },
        {
          "area": "tasks",
          "phases": [
            "P09"
          ],
          "en": "Typing # in task notes suggests the project’s tags (or a new one); the picked tag is also added to the task",
          "fa": "با تایپ # در یادداشت تسک، تگ‌های پروژه (یا یک تگ تازه) پیشنهاد می‌شود و تگ انتخاب‌شده به تسک هم اضافه می‌شود"
        },
        {
          "area": "app",
          "phases": [
            "P15"
          ],
          "en": "What’s new can show a picture next to a change",
          "fa": "در «تازه‌ها» می‌توان کنار هر تغییر تصویری از آن نشان داد"
        },
        {
          "area": "account",
          "phases": [
            "P03",
            "P13"
          ],
          "en": "Everyone has a @username; mention people with @username",
          "fa": "هر کس یک نام کاربری (@username) دارد؛ افراد را با @نام‌کاربری منشن کنید"
        },
        {
          "area": "sharing",
          "phases": [
            "P13"
          ],
          "en": "Share a project by email or @username; it arrives as an invite the person can accept or decline in Invites",
          "fa": "اشتراک پروژه با ایمیل یا @نام‌کاربری؛ به‌صورت دعوت‌نامه می‌رسد و در «دعوت‌ها» پذیرفته یا رد می‌شود"
        },
        {
          "area": "sharing",
          "phases": [
            "P13"
          ],
          "en": "Pending invites show in Shared with and can be cancelled",
          "fa": "دعوت‌های در انتظار در فهرست «اشتراک با» دیده می‌شوند و قابل لغوند"
        },
        {
          "area": "sharing",
          "phases": [
            "P13"
          ],
          "en": "Read-only links for a whole project, one list or one tag; copy them or turn them off any time",
          "fa": "لینک فقط‌خواندنی برای کل پروژه، یک لیست یا یک تگ؛ هر وقت خواستید کپی یا غیرفعالش کنید"
        },
        {
          "area": "trash",
          "phases": [
            "P10"
          ],
          "en": "Delete a project from its settings (owner only); it stays in Trash for 30 days and can be restored",
          "fa": "حذف پروژه از تنظیمات آن (فقط مالک)؛ ۳۰ روز در سطل زباله می‌ماند و قابل بازگردانی است"
        },
        {
          "area": "files",
          "phases": [
            "P12"
          ],
          "en": "Markdown attachments open in their own column with Edit, Split and Preview, a formatting toolbar and autosave",
          "fa": "پیوست‌های مارک‌داون در ستون خودشان با حالت ویرایش، دوستونه و پیش‌نمایش، نوار ابزار قالب‌بندی و ذخیرهٔ خودکار باز می‌شوند"
        },
        {
          "area": "files",
          "phases": [
            "P12"
          ],
          "en": "Markdown version history: preview any earlier version and restore it; open a file in a large pop-up",
          "fa": "تاریخچهٔ نسخه‌های مارک‌داون: هر نسخهٔ قبلی را ببینید و بازگردانید؛ باز کردن فایل در پنجرهٔ بزرگ"
        }
      ],
      "highlights": [
        {
          "en": "Search for projects and tasks",
          "fa": "جستجو در پروژه‌ها و تسک‌ها"
        },
        {
          "en": "Invites by email or @username",
          "fa": "دعوت با ایمیل یا @username"
        },
        {
          "en": "Read-only links for a project, list or tag",
          "fa": "لینک فقط‌خواندنی برای پروژه، لیست یا تگ"
        },
        {
          "en": "Markdown files with editor, preview and version history",
          "fa": "فایل‌های Markdown با ادیتور، پیش‌نمایش و تاریخچه‌ی نسخه‌ها"
        },
        {
          "en": "Delete projects, with 30 days in Trash",
          "fa": "حذف پروژه با نگهداری ۳۰ روزه در سطل زباله"
        }
      ]
    },
    {
      "version": "0.1.2",
      "status": "released",
      "date": "2026-10-03",
      "items": [
        {
          "area": "account",
          "phases": [
            "P03"
          ],
          "en": "Sign in or create an account with Google",
          "fa": "ورود یا ساخت حساب با گوگل"
        },
        {
          "area": "layout",
          "phases": [
            "P08"
          ],
          "en": "Open projects side by side, show the same project in several panes with different tag filters, and resize or reorder panes",
          "fa": "پروژه‌ها را کنار هم باز کنید، یک پروژه را در چند ستون با فیلتر برچسب متفاوت ببینید و ستون‌ها را جابه‌جا یا هم‌اندازه کنید"
        },
        {
          "area": "app",
          "phases": [
            "P04",
            "P05"
          ],
          "en": "Works offline: create, edit, complete and move tasks without a connection; changes sync automatically when you are back online",
          "fa": "کار آفلاین: بدون اینترنت تسک بسازید، ویرایش کنید، انجام‌شده علامت بزنید و جابه‌جا کنید؛ با برگشت اتصال همه‌چیز خودکار همگام می‌شود"
        },
        {
          "area": "app",
          "phases": [
            "P05",
            "P06"
          ],
          "en": "Sync status with the number of changes waiting to sync, and a review sheet when the same field was edited on two devices",
          "fa": "وضعیت همگام‌سازی با تعداد تغییرهای در انتظار، و صفحهٔ بررسی وقتی یک فیلد روی دو دستگاه ویرایش شده باشد"
        },
        {
          "area": "tasks",
          "phases": [
            "P09",
            "P10"
          ],
          "en": "Tasks with notes, checklists, tags and drag-and-drop ordering, with Undo for 5 seconds after a change",
          "fa": "تسک با یادداشت، چک‌لیست، برچسب و مرتب‌سازی با کشیدن و رها کردن، همراه با «واگرد» تا ۵ ثانیه پس از هر تغییر"
        },
        {
          "area": "trash",
          "phases": [
            "P10"
          ],
          "en": "Trash keeps deleted tasks for 30 days so you can restore them",
          "fa": "سطل زباله تسک‌های حذف‌شده را ۳۰ روز نگه می‌دارد تا بتوانید بازگردانید"
        },
        {
          "area": "dates",
          "phases": [
            "P11"
          ],
          "en": "Deadlines with Gregorian and Persian calendars, and reminders in your own time zone",
          "fa": "مهلت با تقویم میلادی و شمسی، و یادآوری بر اساس منطقهٔ زمانی خودتان"
        },
        {
          "area": "look",
          "phases": [
            "P07"
          ],
          "en": "Persian and English, with right-to-left layout for Persian",
          "fa": "فارسی و انگلیسی، با چیدمان راست‌به‌چپ برای فارسی"
        },
        {
          "area": "files",
          "phases": [
            "P12"
          ],
          "en": "Private attachments; files added while offline upload when you reconnect",
          "fa": "پیوست‌های خصوصی؛ فایل‌هایی که آفلاین اضافه می‌کنید پس از اتصال بارگذاری می‌شوند"
        },
        {
          "area": "sharing",
          "phases": [
            "P13"
          ],
          "en": "Share projects, invite people by email, mention teammates with @ and see field-by-field change history",
          "fa": "اشتراک پروژه، دعوت با ایمیل، منشن هم‌تیمی‌ها با @ و تاریخچهٔ تغییر هر فیلد"
        },
        {
          "area": "comments",
          "phases": [
            "P14"
          ],
          "en": "Notifications for mentions, shared projects and invitations, with optional email",
          "fa": "اعلان برای منشن‌ها، پروژه‌های اشتراکی و دعوت‌ها، با ایمیل اختیاری"
        },
        {
          "area": "stats",
          "phases": [
            "P15"
          ],
          "en": "Stats for each project and for all projects together; throughput (completed ÷ added) can exceed 100%",
          "fa": "آمار هر پروژه و همهٔ پروژه‌ها؛ نرخ بازده (انجام‌شده ÷ اضافه‌شده) می‌تواند از ۱۰۰٪ بیشتر شود"
        },
        {
          "area": "account",
          "phases": [
            "P15"
          ],
          "en": "Your preferences are saved to your account and follow you to your other devices",
          "fa": "تنظیمات شما در حسابتان ذخیره می‌شود و روی دستگاه‌های دیگرتان هم اعمال می‌شود"
        },
        {
          "area": "look",
          "phases": [
            "P07",
            "P19"
          ],
          "en": "Themes, accent colors and densities, plus a High contrast theme",
          "fa": "پوسته‌ها، رنگ تأکیدی و تراکم نمایش، به‌همراه پوستهٔ کنتراست بالا"
        },
        {
          "area": "app",
          "phases": [
            "P17"
          ],
          "en": "Workspace plans with member, project and storage limits",
          "fa": "پلن‌های فضای کاری با سقف اعضا، پروژه و فضای ذخیره‌سازی"
        },
        {
          "area": "mobile",
          "phases": [
            "P18"
          ],
          "en": "Install as an app; updates wait until you choose to reload, so unsynced edits are never lost",
          "fa": "نصب به‌عنوان اپ؛ به‌روزرسانی تا انتخاب خودتان منتظر می‌ماند تا ویرایش‌های همگام‌نشده از بین نروند"
        },
        {
          "area": "app",
          "phases": [
            "P16"
          ],
          "en": "A clear message when the site address is not set up yet",
          "fa": "پیام روشن وقتی نشانی سایت هنوز راه‌اندازی نشده است"
        }
      ],
      "highlights": [
        {
          "en": "Works offline and syncs when you reconnect",
          "fa": "کار بدون اینترنت و همگام‌سازی پس از اتصال"
        },
        {
          "en": "Projects side by side with tag filters",
          "fa": "پروژه‌ها کنار هم با فیلتر تگ"
        },
        {
          "en": "Sharing, mentions and change history",
          "fa": "اشتراک‌گذاری، منشن و تاریخچه‌ی تغییرات"
        },
        {
          "en": "Persian and English, Persian calendar",
          "fa": "فارسی و انگلیسی، تقویم شمسی"
        }
      ]
    }
  ]
}
